define(function() { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["notifWebpackP"];
/******/ 	window["notifWebpackP"] = function webpackJsonpCallback(chunkIds, moreModules, executeModule) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		0: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve()
/******/
/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".NotificationsMain.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		return installedChunks[chunkId][2] = promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { throw err; };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Riot v2.6.8, @license MIT */
	
	;(function(window, undefined) {
	  'use strict';
	var riot = { version: 'v2.6.8', settings: {} },
	  // be aware, internal usage
	  // ATTENTION: prefix the global dynamic variables with `__`
	
	  // counter to give a unique id to all the Tag instances
	  __uid = 0,
	  // tags instances cache
	  __virtualDom = [],
	  // tags implementation cache
	  __tagImpl = {},
	
	  /**
	   * Const
	   */
	  GLOBAL_MIXIN = '__global_mixin',
	
	  // riot specific prefixes
	  RIOT_PREFIX = 'riot-',
	  RIOT_TAG = RIOT_PREFIX + 'tag',
	  RIOT_TAG_IS = 'data-is',
	
	  // for typeof == '' comparisons
	  T_STRING = 'string',
	  T_OBJECT = 'object',
	  T_UNDEF  = 'undefined',
	  T_FUNCTION = 'function',
	  XLINK_NS = 'http://www.w3.org/1999/xlink',
	  XLINK_REGEX = /^xlink:(\w+)/,
	  // special native tags that cannot be treated like the others
	  SPECIAL_TAGS_REGEX = /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?|opt(?:ion|group))$/,
	  RESERVED_WORDS_BLACKLIST = /^(?:_(?:item|id|parent)|update|root|(?:un)?mount|mixin|is(?:Mounted|Loop)|tags|parent|opts|trigger|o(?:n|ff|ne))$/,
	  // SVG tags list https://www.w3.org/TR/SVG/attindex.html#PresentationAttributes
	  SVG_TAGS_LIST = ['altGlyph', 'animate', 'animateColor', 'circle', 'clipPath', 'defs', 'ellipse', 'feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feFlood', 'feGaussianBlur', 'feImage', 'feMerge', 'feMorphology', 'feOffset', 'feSpecularLighting', 'feTile', 'feTurbulence', 'filter', 'font', 'foreignObject', 'g', 'glyph', 'glyphRef', 'image', 'line', 'linearGradient', 'marker', 'mask', 'missing-glyph', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'switch', 'symbol', 'text', 'textPath', 'tref', 'tspan', 'use'],
	
	  // version# for IE 8-11, 0 for others
	  IE_VERSION = (window && window.document || {}).documentMode | 0,
	
	  // detect firefox to fix #1374
	  FIREFOX = window && !!window.InstallTrigger
	/* istanbul ignore next */
	riot.observable = function(el) {
	
	  /**
	   * Extend the original object or create a new empty one
	   * @type { Object }
	   */
	
	  el = el || {}
	
	  /**
	   * Private variables
	   */
	  var callbacks = {},
	    slice = Array.prototype.slice
	
	  /**
	   * Private Methods
	   */
	
	  /**
	   * Helper function needed to get and loop all the events in a string
	   * @param   { String }   e - event string
	   * @param   {Function}   fn - callback
	   */
	  function onEachEvent(e, fn) {
	    var es = e.split(' '), l = es.length, i = 0
	    for (; i < l; i++) {
	      var name = es[i]
	      if (name) fn(name, i)
	    }
	  }
	
	  /**
	   * Public Api
	   */
	
	  // extend the el object adding the observable methods
	  Object.defineProperties(el, {
	    /**
	     * Listen to the given space separated list of `events` and
	     * execute the `callback` each time an event is triggered.
	     * @param  { String } events - events ids
	     * @param  { Function } fn - callback function
	     * @returns { Object } el
	     */
	    on: {
	      value: function(events, fn) {
	        if (typeof fn != 'function')  return el
	
	        onEachEvent(events, function(name, pos) {
	          (callbacks[name] = callbacks[name] || []).push(fn)
	          fn.typed = pos > 0
	        })
	
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Removes the given space separated list of `events` listeners
	     * @param   { String } events - events ids
	     * @param   { Function } fn - callback function
	     * @returns { Object } el
	     */
	    off: {
	      value: function(events, fn) {
	        if (events == '*' && !fn) callbacks = {}
	        else {
	          onEachEvent(events, function(name, pos) {
	            if (fn) {
	              var arr = callbacks[name]
	              for (var i = 0, cb; cb = arr && arr[i]; ++i) {
	                if (cb == fn) arr.splice(i--, 1)
	              }
	            } else delete callbacks[name]
	          })
	        }
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Listen to the given space separated list of `events` and
	     * execute the `callback` at most once
	     * @param   { String } events - events ids
	     * @param   { Function } fn - callback function
	     * @returns { Object } el
	     */
	    one: {
	      value: function(events, fn) {
	        function on() {
	          el.off(events, on)
	          fn.apply(el, arguments)
	        }
	        return el.on(events, on)
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    },
	
	    /**
	     * Execute all callback functions that listen to
	     * the given space separated list of `events`
	     * @param   { String } events - events ids
	     * @returns { Object } el
	     */
	    trigger: {
	      value: function(events) {
	
	        // getting the arguments
	        var arglen = arguments.length - 1,
	          args = new Array(arglen),
	          fns
	
	        for (var i = 0; i < arglen; i++) {
	          args[i] = arguments[i + 1] // skip first argument
	        }
	
	        onEachEvent(events, function(name, pos) {
	
	          fns = slice.call(callbacks[name] || [], 0)
	
	          for (var i = 0, fn; fn = fns[i]; ++i) {
	            if (fn.busy) continue
	            fn.busy = 1
	            fn.apply(el, fn.typed ? [name].concat(args) : args)
	            if (fns[i] !== fn) { i-- }
	            fn.busy = 0
	          }
	
	          if (callbacks['*'] && name != '*')
	            el.trigger.apply(el, ['*', name].concat(args))
	
	        })
	
	        return el
	      },
	      enumerable: false,
	      writable: false,
	      configurable: false
	    }
	  })
	
	  return el
	
	}
	/* istanbul ignore next */
	;(function(riot) {
	
	/**
	 * Simple client-side router
	 * @module riot-route
	 */
	
	
	var RE_ORIGIN = /^.+?\/\/+[^\/]+/,
	  EVENT_LISTENER = 'EventListener',
	  REMOVE_EVENT_LISTENER = 'remove' + EVENT_LISTENER,
	  ADD_EVENT_LISTENER = 'add' + EVENT_LISTENER,
	  HAS_ATTRIBUTE = 'hasAttribute',
	  REPLACE = 'replace',
	  POPSTATE = 'popstate',
	  HASHCHANGE = 'hashchange',
	  TRIGGER = 'trigger',
	  MAX_EMIT_STACK_LEVEL = 3,
	  win = typeof window != 'undefined' && window,
	  doc = typeof document != 'undefined' && document,
	  hist = win && history,
	  loc = win && (hist.location || win.location), // see html5-history-api
	  prot = Router.prototype, // to minify more
	  clickEvent = doc && doc.ontouchstart ? 'touchstart' : 'click',
	  started = false,
	  central = riot.observable(),
	  routeFound = false,
	  debouncedEmit,
	  base, current, parser, secondParser, emitStack = [], emitStackLevel = 0
	
	/**
	 * Default parser. You can replace it via router.parser method.
	 * @param {string} path - current path (normalized)
	 * @returns {array} array
	 */
	function DEFAULT_PARSER(path) {
	  return path.split(/[/?#]/)
	}
	
	/**
	 * Default parser (second). You can replace it via router.parser method.
	 * @param {string} path - current path (normalized)
	 * @param {string} filter - filter string (normalized)
	 * @returns {array} array
	 */
	function DEFAULT_SECOND_PARSER(path, filter) {
	  var re = new RegExp('^' + filter[REPLACE](/\*/g, '([^/?#]+?)')[REPLACE](/\.\./, '.*') + '$'),
	    args = path.match(re)
	
	  if (args) return args.slice(1)
	}
	
	/**
	 * Simple/cheap debounce implementation
	 * @param   {function} fn - callback
	 * @param   {number} delay - delay in seconds
	 * @returns {function} debounced function
	 */
	function debounce(fn, delay) {
	  var t
	  return function () {
	    clearTimeout(t)
	    t = setTimeout(fn, delay)
	  }
	}
	
	/**
	 * Set the window listeners to trigger the routes
	 * @param {boolean} autoExec - see route.start
	 */
	function start(autoExec) {
	  debouncedEmit = debounce(emit, 1)
	  win[ADD_EVENT_LISTENER](POPSTATE, debouncedEmit)
	  win[ADD_EVENT_LISTENER](HASHCHANGE, debouncedEmit)
	  doc[ADD_EVENT_LISTENER](clickEvent, click)
	  if (autoExec) emit(true)
	}
	
	/**
	 * Router class
	 */
	function Router() {
	  this.$ = []
	  riot.observable(this) // make it observable
	  central.on('stop', this.s.bind(this))
	  central.on('emit', this.e.bind(this))
	}
	
	function normalize(path) {
	  return path[REPLACE](/^\/|\/$/, '')
	}
	
	function isString(str) {
	  return typeof str == 'string'
	}
	
	/**
	 * Get the part after domain name
	 * @param {string} href - fullpath
	 * @returns {string} path from root
	 */
	function getPathFromRoot(href) {
	  return (href || loc.href)[REPLACE](RE_ORIGIN, '')
	}
	
	/**
	 * Get the part after base
	 * @param {string} href - fullpath
	 * @returns {string} path from base
	 */
	function getPathFromBase(href) {
	  return base[0] == '#'
	    ? (href || loc.href || '').split(base)[1] || ''
	    : (loc ? getPathFromRoot(href) : href || '')[REPLACE](base, '')
	}
	
	function emit(force) {
	  // the stack is needed for redirections
	  var isRoot = emitStackLevel == 0, first
	  if (MAX_EMIT_STACK_LEVEL <= emitStackLevel) return
	
	  emitStackLevel++
	  emitStack.push(function() {
	    var path = getPathFromBase()
	    if (force || path != current) {
	      central[TRIGGER]('emit', path)
	      current = path
	    }
	  })
	  if (isRoot) {
	    while (first = emitStack.shift()) first() // stack increses within this call
	    emitStackLevel = 0
	  }
	}
	
	function click(e) {
	  if (
	    e.which != 1 // not left click
	    || e.metaKey || e.ctrlKey || e.shiftKey // or meta keys
	    || e.defaultPrevented // or default prevented
	  ) return
	
	  var el = e.target
	  while (el && el.nodeName != 'A') el = el.parentNode
	
	  if (
	    !el || el.nodeName != 'A' // not A tag
	    || el[HAS_ATTRIBUTE]('download') // has download attr
	    || !el[HAS_ATTRIBUTE]('href') // has no href attr
	    || el.target && el.target != '_self' // another window or frame
	    || el.href.indexOf(loc.href.match(RE_ORIGIN)[0]) == -1 // cross origin
	  ) return
	
	  if (el.href != loc.href
	    && (
	      el.href.split('#')[0] == loc.href.split('#')[0] // internal jump
	      || base[0] != '#' && getPathFromRoot(el.href).indexOf(base) !== 0 // outside of base
	      || base[0] == '#' && el.href.split(base)[0] != loc.href.split(base)[0] // outside of #base
	      || !go(getPathFromBase(el.href), el.title || doc.title) // route not found
	    )) return
	
	  e.preventDefault()
	}
	
	/**
	 * Go to the path
	 * @param {string} path - destination path
	 * @param {string} title - page title
	 * @param {boolean} shouldReplace - use replaceState or pushState
	 * @returns {boolean} - route not found flag
	 */
	function go(path, title, shouldReplace) {
	  // Server-side usage: directly execute handlers for the path
	  if (!hist) return central[TRIGGER]('emit', getPathFromBase(path))
	
	  path = base + normalize(path)
	  title = title || doc.title
	  // browsers ignores the second parameter `title`
	  shouldReplace
	    ? hist.replaceState(null, title, path)
	    : hist.pushState(null, title, path)
	  // so we need to set it manually
	  doc.title = title
	  routeFound = false
	  emit()
	  return routeFound
	}
	
	/**
	 * Go to path or set action
	 * a single string:                go there
	 * two strings:                    go there with setting a title
	 * two strings and boolean:        replace history with setting a title
	 * a single function:              set an action on the default route
	 * a string/RegExp and a function: set an action on the route
	 * @param {(string|function)} first - path / action / filter
	 * @param {(string|RegExp|function)} second - title / action
	 * @param {boolean} third - replace flag
	 */
	prot.m = function(first, second, third) {
	  if (isString(first) && (!second || isString(second))) go(first, second, third || false)
	  else if (second) this.r(first, second)
	  else this.r('@', first)
	}
	
	/**
	 * Stop routing
	 */
	prot.s = function() {
	  this.off('*')
	  this.$ = []
	}
	
	/**
	 * Emit
	 * @param {string} path - path
	 */
	prot.e = function(path) {
	  this.$.concat('@').some(function(filter) {
	    var args = (filter == '@' ? parser : secondParser)(normalize(path), normalize(filter))
	    if (typeof args != 'undefined') {
	      this[TRIGGER].apply(null, [filter].concat(args))
	      return routeFound = true // exit from loop
	    }
	  }, this)
	}
	
	/**
	 * Register route
	 * @param {string} filter - filter for matching to url
	 * @param {function} action - action to register
	 */
	prot.r = function(filter, action) {
	  if (filter != '@') {
	    filter = '/' + normalize(filter)
	    this.$.push(filter)
	  }
	  this.on(filter, action)
	}
	
	var mainRouter = new Router()
	var route = mainRouter.m.bind(mainRouter)
	
	/**
	 * Create a sub router
	 * @returns {function} the method of a new Router object
	 */
	route.create = function() {
	  var newSubRouter = new Router()
	  // assign sub-router's main method
	  var router = newSubRouter.m.bind(newSubRouter)
	  // stop only this sub-router
	  router.stop = newSubRouter.s.bind(newSubRouter)
	  return router
	}
	
	/**
	 * Set the base of url
	 * @param {(str|RegExp)} arg - a new base or '#' or '#!'
	 */
	route.base = function(arg) {
	  base = arg || '#'
	  current = getPathFromBase() // recalculate current path
	}
	
	/** Exec routing right now **/
	route.exec = function() {
	  emit(true)
	}
	
	/**
	 * Replace the default router to yours
	 * @param {function} fn - your parser function
	 * @param {function} fn2 - your secondParser function
	 */
	route.parser = function(fn, fn2) {
	  if (!fn && !fn2) {
	    // reset parser for testing...
	    parser = DEFAULT_PARSER
	    secondParser = DEFAULT_SECOND_PARSER
	  }
	  if (fn) parser = fn
	  if (fn2) secondParser = fn2
	}
	
	/**
	 * Helper function to get url query as an object
	 * @returns {object} parsed query
	 */
	route.query = function() {
	  var q = {}
	  var href = loc.href || current
	  href[REPLACE](/[?&](.+?)=([^&]*)/g, function(_, k, v) { q[k] = v })
	  return q
	}
	
	/** Stop routing **/
	route.stop = function () {
	  if (started) {
	    if (win) {
	      win[REMOVE_EVENT_LISTENER](POPSTATE, debouncedEmit)
	      win[REMOVE_EVENT_LISTENER](HASHCHANGE, debouncedEmit)
	      doc[REMOVE_EVENT_LISTENER](clickEvent, click)
	    }
	    central[TRIGGER]('stop')
	    started = false
	  }
	}
	
	/**
	 * Start routing
	 * @param {boolean} autoExec - automatically exec after starting if true
	 */
	route.start = function (autoExec) {
	  if (!started) {
	    if (win) {
	      if (document.readyState == 'complete') start(autoExec)
	      // the timeout is needed to solve
	      // a weird safari bug https://github.com/riot/route/issues/33
	      else win[ADD_EVENT_LISTENER]('load', function() {
	        setTimeout(function() { start(autoExec) }, 1)
	      })
	    }
	    started = true
	  }
	}
	
	/** Prepare the router **/
	route.base()
	route.parser()
	
	riot.route = route
	})(riot)
	/* istanbul ignore next */
	
	/**
	 * The riot template engine
	 * @version v2.4.2
	 */
	/**
	 * riot.util.brackets
	 *
	 * - `brackets    ` - Returns a string or regex based on its parameter
	 * - `brackets.set` - Change the current riot brackets
	 *
	 * @module
	 */
	
	var brackets = (function (UNDEF) {
	
	  var
	    REGLOB = 'g',
	
	    R_MLCOMMS = /\/\*[^*]*\*+(?:[^*\/][^*]*\*+)*\//g,
	
	    R_STRINGS = /"[^"\\]*(?:\\[\S\s][^"\\]*)*"|'[^'\\]*(?:\\[\S\s][^'\\]*)*'/g,
	
	    S_QBLOCKS = R_STRINGS.source + '|' +
	      /(?:\breturn\s+|(?:[$\w\)\]]|\+\+|--)\s*(\/)(?![*\/]))/.source + '|' +
	      /\/(?=[^*\/])[^[\/\\]*(?:(?:\[(?:\\.|[^\]\\]*)*\]|\\.)[^[\/\\]*)*?(\/)[gim]*/.source,
	
	    UNSUPPORTED = RegExp('[\\' + 'x00-\\x1F<>a-zA-Z0-9\'",;\\\\]'),
	
	    NEED_ESCAPE = /(?=[[\]()*+?.^$|])/g,
	
	    FINDBRACES = {
	      '(': RegExp('([()])|'   + S_QBLOCKS, REGLOB),
	      '[': RegExp('([[\\]])|' + S_QBLOCKS, REGLOB),
	      '{': RegExp('([{}])|'   + S_QBLOCKS, REGLOB)
	    },
	
	    DEFAULT = '{ }'
	
	  var _pairs = [
	    '{', '}',
	    '{', '}',
	    /{[^}]*}/,
	    /\\([{}])/g,
	    /\\({)|{/g,
	    RegExp('\\\\(})|([[({])|(})|' + S_QBLOCKS, REGLOB),
	    DEFAULT,
	    /^\s*{\^?\s*([$\w]+)(?:\s*,\s*(\S+))?\s+in\s+(\S.*)\s*}/,
	    /(^|[^\\]){=[\S\s]*?}/
	  ]
	
	  var
	    cachedBrackets = UNDEF,
	    _regex,
	    _cache = [],
	    _settings
	
	  function _loopback (re) { return re }
	
	  function _rewrite (re, bp) {
	    if (!bp) bp = _cache
	    return new RegExp(
	      re.source.replace(/{/g, bp[2]).replace(/}/g, bp[3]), re.global ? REGLOB : ''
	    )
	  }
	
	  function _create (pair) {
	    if (pair === DEFAULT) return _pairs
	
	    var arr = pair.split(' ')
	
	    if (arr.length !== 2 || UNSUPPORTED.test(pair)) {
	      throw new Error('Unsupported brackets "' + pair + '"')
	    }
	    arr = arr.concat(pair.replace(NEED_ESCAPE, '\\').split(' '))
	
	    arr[4] = _rewrite(arr[1].length > 1 ? /{[\S\s]*?}/ : _pairs[4], arr)
	    arr[5] = _rewrite(pair.length > 3 ? /\\({|})/g : _pairs[5], arr)
	    arr[6] = _rewrite(_pairs[6], arr)
	    arr[7] = RegExp('\\\\(' + arr[3] + ')|([[({])|(' + arr[3] + ')|' + S_QBLOCKS, REGLOB)
	    arr[8] = pair
	    return arr
	  }
	
	  function _brackets (reOrIdx) {
	    return reOrIdx instanceof RegExp ? _regex(reOrIdx) : _cache[reOrIdx]
	  }
	
	  _brackets.split = function split (str, tmpl, _bp) {
	    // istanbul ignore next: _bp is for the compiler
	    if (!_bp) _bp = _cache
	
	    var
	      parts = [],
	      match,
	      isexpr,
	      start,
	      pos,
	      re = _bp[6]
	
	    isexpr = start = re.lastIndex = 0
	
	    while ((match = re.exec(str))) {
	
	      pos = match.index
	
	      if (isexpr) {
	
	        if (match[2]) {
	          re.lastIndex = skipBraces(str, match[2], re.lastIndex)
	          continue
	        }
	        if (!match[3]) {
	          continue
	        }
	      }
	
	      if (!match[1]) {
	        unescapeStr(str.slice(start, pos))
	        start = re.lastIndex
	        re = _bp[6 + (isexpr ^= 1)]
	        re.lastIndex = start
	      }
	    }
	
	    if (str && start < str.length) {
	      unescapeStr(str.slice(start))
	    }
	
	    return parts
	
	    function unescapeStr (s) {
	      if (tmpl || isexpr) {
	        parts.push(s && s.replace(_bp[5], '$1'))
	      } else {
	        parts.push(s)
	      }
	    }
	
	    function skipBraces (s, ch, ix) {
	      var
	        match,
	        recch = FINDBRACES[ch]
	
	      recch.lastIndex = ix
	      ix = 1
	      while ((match = recch.exec(s))) {
	        if (match[1] &&
	          !(match[1] === ch ? ++ix : --ix)) break
	      }
	      return ix ? s.length : recch.lastIndex
	    }
	  }
	
	  _brackets.hasExpr = function hasExpr (str) {
	    return _cache[4].test(str)
	  }
	
	  _brackets.loopKeys = function loopKeys (expr) {
	    var m = expr.match(_cache[9])
	
	    return m
	      ? { key: m[1], pos: m[2], val: _cache[0] + m[3].trim() + _cache[1] }
	      : { val: expr.trim() }
	  }
	
	  _brackets.array = function array (pair) {
	    return pair ? _create(pair) : _cache
	  }
	
	  function _reset (pair) {
	    if ((pair || (pair = DEFAULT)) !== _cache[8]) {
	      _cache = _create(pair)
	      _regex = pair === DEFAULT ? _loopback : _rewrite
	      _cache[9] = _regex(_pairs[9])
	    }
	    cachedBrackets = pair
	  }
	
	  function _setSettings (o) {
	    var b
	
	    o = o || {}
	    b = o.brackets
	    Object.defineProperty(o, 'brackets', {
	      set: _reset,
	      get: function () { return cachedBrackets },
	      enumerable: true
	    })
	    _settings = o
	    _reset(b)
	  }
	
	  Object.defineProperty(_brackets, 'settings', {
	    set: _setSettings,
	    get: function () { return _settings }
	  })
	
	  /* istanbul ignore next: in the browser riot is always in the scope */
	  _brackets.settings = typeof riot !== 'undefined' && riot.settings || {}
	  _brackets.set = _reset
	
	  _brackets.R_STRINGS = R_STRINGS
	  _brackets.R_MLCOMMS = R_MLCOMMS
	  _brackets.S_QBLOCKS = S_QBLOCKS
	
	  return _brackets
	
	})()
	
	/**
	 * @module tmpl
	 *
	 * tmpl          - Root function, returns the template value, render with data
	 * tmpl.hasExpr  - Test the existence of a expression inside a string
	 * tmpl.loopKeys - Get the keys for an 'each' loop (used by `_each`)
	 */
	
	var tmpl = (function () {
	
	  var _cache = {}
	
	  function _tmpl (str, data) {
	    if (!str) return str
	
	    return (_cache[str] || (_cache[str] = _create(str))).call(data, _logErr)
	  }
	
	  _tmpl.haveRaw = brackets.hasRaw
	
	  _tmpl.hasExpr = brackets.hasExpr
	
	  _tmpl.loopKeys = brackets.loopKeys
	
	  // istanbul ignore next
	  _tmpl.clearCache = function () { _cache = {} }
	
	  _tmpl.errorHandler = null
	
	  function _logErr (err, ctx) {
	
	    if (_tmpl.errorHandler) {
	
	      err.riotData = {
	        tagName: ctx && ctx.root && ctx.root.tagName,
	        _riot_id: ctx && ctx._riot_id  //eslint-disable-line camelcase
	      }
	      _tmpl.errorHandler(err)
	    }
	  }
	
	  function _create (str) {
	    var expr = _getTmpl(str)
	
	    if (expr.slice(0, 11) !== 'try{return ') expr = 'return ' + expr
	
	    return new Function('E', expr + ';')    // eslint-disable-line no-new-func
	  }
	
	  var
	    CH_IDEXPR = String.fromCharCode(0x2057),
	    RE_CSNAME = /^(?:(-?[_A-Za-z\xA0-\xFF][-\w\xA0-\xFF]*)|\u2057(\d+)~):/,
	    RE_QBLOCK = RegExp(brackets.S_QBLOCKS, 'g'),
	    RE_DQUOTE = /\u2057/g,
	    RE_QBMARK = /\u2057(\d+)~/g
	
	  function _getTmpl (str) {
	    var
	      qstr = [],
	      expr,
	      parts = brackets.split(str.replace(RE_DQUOTE, '"'), 1)
	
	    if (parts.length > 2 || parts[0]) {
	      var i, j, list = []
	
	      for (i = j = 0; i < parts.length; ++i) {
	
	        expr = parts[i]
	
	        if (expr && (expr = i & 1
	
	            ? _parseExpr(expr, 1, qstr)
	
	            : '"' + expr
	                .replace(/\\/g, '\\\\')
	                .replace(/\r\n?|\n/g, '\\n')
	                .replace(/"/g, '\\"') +
	              '"'
	
	          )) list[j++] = expr
	
	      }
	
	      expr = j < 2 ? list[0]
	           : '[' + list.join(',') + '].join("")'
	
	    } else {
	
	      expr = _parseExpr(parts[1], 0, qstr)
	    }
	
	    if (qstr[0]) {
	      expr = expr.replace(RE_QBMARK, function (_, pos) {
	        return qstr[pos]
	          .replace(/\r/g, '\\r')
	          .replace(/\n/g, '\\n')
	      })
	    }
	    return expr
	  }
	
	  var
	    RE_BREND = {
	      '(': /[()]/g,
	      '[': /[[\]]/g,
	      '{': /[{}]/g
	    }
	
	  function _parseExpr (expr, asText, qstr) {
	
	    expr = expr
	          .replace(RE_QBLOCK, function (s, div) {
	            return s.length > 2 && !div ? CH_IDEXPR + (qstr.push(s) - 1) + '~' : s
	          })
	          .replace(/\s+/g, ' ').trim()
	          .replace(/\ ?([[\({},?\.:])\ ?/g, '$1')
	
	    if (expr) {
	      var
	        list = [],
	        cnt = 0,
	        match
	
	      while (expr &&
	            (match = expr.match(RE_CSNAME)) &&
	            !match.index
	        ) {
	        var
	          key,
	          jsb,
	          re = /,|([[{(])|$/g
	
	        expr = RegExp.rightContext
	        key  = match[2] ? qstr[match[2]].slice(1, -1).trim().replace(/\s+/g, ' ') : match[1]
	
	        while (jsb = (match = re.exec(expr))[1]) skipBraces(jsb, re)
	
	        jsb  = expr.slice(0, match.index)
	        expr = RegExp.rightContext
	
	        list[cnt++] = _wrapExpr(jsb, 1, key)
	      }
	
	      expr = !cnt ? _wrapExpr(expr, asText)
	           : cnt > 1 ? '[' + list.join(',') + '].join(" ").trim()' : list[0]
	    }
	    return expr
	
	    function skipBraces (ch, re) {
	      var
	        mm,
	        lv = 1,
	        ir = RE_BREND[ch]
	
	      ir.lastIndex = re.lastIndex
	      while (mm = ir.exec(expr)) {
	        if (mm[0] === ch) ++lv
	        else if (!--lv) break
	      }
	      re.lastIndex = lv ? expr.length : ir.lastIndex
	    }
	  }
	
	  // istanbul ignore next: not both
	  var // eslint-disable-next-line max-len
	    JS_CONTEXT = '"in this?this:' + (typeof window !== 'object' ? 'global' : 'window') + ').',
	    JS_VARNAME = /[,{][\$\w]+(?=:)|(^ *|[^$\w\.{])(?!(?:typeof|true|false|null|undefined|in|instanceof|is(?:Finite|NaN)|void|NaN|new|Date|RegExp|Math)(?![$\w]))([$_A-Za-z][$\w]*)/g,
	    JS_NOPROPS = /^(?=(\.[$\w]+))\1(?:[^.[(]|$)/
	
	  function _wrapExpr (expr, asText, key) {
	    var tb
	
	    expr = expr.replace(JS_VARNAME, function (match, p, mvar, pos, s) {
	      if (mvar) {
	        pos = tb ? 0 : pos + match.length
	
	        if (mvar !== 'this' && mvar !== 'global' && mvar !== 'window') {
	          match = p + '("' + mvar + JS_CONTEXT + mvar
	          if (pos) tb = (s = s[pos]) === '.' || s === '(' || s === '['
	        } else if (pos) {
	          tb = !JS_NOPROPS.test(s.slice(pos))
	        }
	      }
	      return match
	    })
	
	    if (tb) {
	      expr = 'try{return ' + expr + '}catch(e){E(e,this)}'
	    }
	
	    if (key) {
	
	      expr = (tb
	          ? 'function(){' + expr + '}.call(this)' : '(' + expr + ')'
	        ) + '?"' + key + '":""'
	
	    } else if (asText) {
	
	      expr = 'function(v){' + (tb
	          ? expr.replace('return ', 'v=') : 'v=(' + expr + ')'
	        ) + ';return v||v===0?v:""}.call(this)'
	    }
	
	    return expr
	  }
	
	  _tmpl.version = brackets.version = 'v2.4.2'
	
	  return _tmpl
	
	})()
	
	/*
	  lib/browser/tag/mkdom.js
	
	  Includes hacks needed for the Internet Explorer version 9 and below
	  See: http://kangax.github.io/compat-table/es5/#ie8
	       http://codeplanet.io/dropping-ie8/
	*/
	var mkdom = (function _mkdom() {
	  var
	    reHasYield  = /<yield\b/i,
	    reYieldAll  = /<yield\s*(?:\/>|>([\S\s]*?)<\/yield\s*>|>)/ig,
	    reYieldSrc  = /<yield\s+to=['"]([^'">]*)['"]\s*>([\S\s]*?)<\/yield\s*>/ig,
	    reYieldDest = /<yield\s+from=['"]?([-\w]+)['"]?\s*(?:\/>|>([\S\s]*?)<\/yield\s*>)/ig
	  var
	    rootEls = { tr: 'tbody', th: 'tr', td: 'tr', col: 'colgroup' },
	    tblTags = IE_VERSION && IE_VERSION < 10
	      ? SPECIAL_TAGS_REGEX : /^(?:t(?:body|head|foot|[rhd])|caption|col(?:group)?)$/
	
	  /**
	   * Creates a DOM element to wrap the given content. Normally an `DIV`, but can be
	   * also a `TABLE`, `SELECT`, `TBODY`, `TR`, or `COLGROUP` element.
	   *
	   * @param   { String } templ  - The template coming from the custom tag definition
	   * @param   { String } [html] - HTML content that comes from the DOM element where you
	   *           will mount the tag, mostly the original tag in the page
	   * @param   { Boolean } checkSvg - flag needed to know if we need to force the svg rendering in case of loop nodes
	   * @returns {HTMLElement} DOM element with _templ_ merged through `YIELD` with the _html_.
	   */
	  function _mkdom(templ, html, checkSvg) {
	    var
	      match   = templ && templ.match(/^\s*<([-\w]+)/),
	      tagName = match && match[1].toLowerCase(),
	      el = mkEl('div', checkSvg && isSVGTag(tagName))
	
	    // replace all the yield tags with the tag inner html
	    templ = replaceYield(templ, html)
	
	    /* istanbul ignore next */
	    if (tblTags.test(tagName))
	      el = specialTags(el, templ, tagName)
	    else
	      setInnerHTML(el, templ)
	
	    el.stub = true
	
	    return el
	  }
	
	  /*
	    Creates the root element for table or select child elements:
	    tr/th/td/thead/tfoot/tbody/caption/col/colgroup/option/optgroup
	  */
	  function specialTags(el, templ, tagName) {
	    var
	      select = tagName[0] === 'o',
	      parent = select ? 'select>' : 'table>'
	
	    // trim() is important here, this ensures we don't have artifacts,
	    // so we can check if we have only one element inside the parent
	    el.innerHTML = '<' + parent + templ.trim() + '</' + parent
	    parent = el.firstChild
	
	    // returns the immediate parent if tr/th/td/col is the only element, if not
	    // returns the whole tree, as this can include additional elements
	    if (select) {
	      parent.selectedIndex = -1  // for IE9, compatible w/current riot behavior
	    } else {
	      // avoids insertion of cointainer inside container (ex: tbody inside tbody)
	      var tname = rootEls[tagName]
	      if (tname && parent.childElementCount === 1) parent = $(tname, parent)
	    }
	    return parent
	  }
	
	  /*
	    Replace the yield tag from any tag template with the innerHTML of the
	    original tag in the page
	  */
	  function replaceYield(templ, html) {
	    // do nothing if no yield
	    if (!reHasYield.test(templ)) return templ
	
	    // be careful with #1343 - string on the source having `$1`
	    var src = {}
	
	    html = html && html.replace(reYieldSrc, function (_, ref, text) {
	      src[ref] = src[ref] || text   // preserve first definition
	      return ''
	    }).trim()
	
	    return templ
	      .replace(reYieldDest, function (_, ref, def) {  // yield with from - to attrs
	        return src[ref] || def || ''
	      })
	      .replace(reYieldAll, function (_, def) {        // yield without any "from"
	        return html || def || ''
	      })
	  }
	
	  return _mkdom
	
	})()
	
	/**
	 * Convert the item looped into an object used to extend the child tag properties
	 * @param   { Object } expr - object containing the keys used to extend the children tags
	 * @param   { * } key - value to assign to the new object returned
	 * @param   { * } val - value containing the position of the item in the array
	 * @returns { Object } - new object containing the values of the original item
	 *
	 * The variables 'key' and 'val' are arbitrary.
	 * They depend on the collection type looped (Array, Object)
	 * and on the expression used on the each tag
	 *
	 */
	function mkitem(expr, key, val) {
	  var item = {}
	  item[expr.key] = key
	  if (expr.pos) item[expr.pos] = val
	  return item
	}
	
	/**
	 * Unmount the redundant tags
	 * @param   { Array } items - array containing the current items to loop
	 * @param   { Array } tags - array containing all the children tags
	 */
	function unmountRedundant(items, tags) {
	
	  var i = tags.length,
	    j = items.length,
	    t
	
	  while (i > j) {
	    t = tags[--i]
	    tags.splice(i, 1)
	    t.unmount()
	  }
	}
	
	/**
	 * Move the nested custom tags in non custom loop tags
	 * @param   { Object } child - non custom loop tag
	 * @param   { Number } i - current position of the loop tag
	 */
	function moveNestedTags(child, i) {
	  Object.keys(child.tags).forEach(function(tagName) {
	    var tag = child.tags[tagName]
	    if (isArray(tag))
	      each(tag, function (t) {
	        moveChildTag(t, tagName, i)
	      })
	    else
	      moveChildTag(tag, tagName, i)
	  })
	}
	
	/**
	 * Adds the elements for a virtual tag
	 * @param { Tag } tag - the tag whose root's children will be inserted or appended
	 * @param { Node } src - the node that will do the inserting or appending
	 * @param { Tag } target - only if inserting, insert before this tag's first child
	 */
	function addVirtual(tag, src, target) {
	  var el = tag._root, sib
	  tag._virts = []
	  while (el) {
	    sib = el.nextSibling
	    if (target)
	      src.insertBefore(el, target._root)
	    else
	      src.appendChild(el)
	
	    tag._virts.push(el) // hold for unmounting
	    el = sib
	  }
	}
	
	/**
	 * Move virtual tag and all child nodes
	 * @param { Tag } tag - first child reference used to start move
	 * @param { Node } src  - the node that will do the inserting
	 * @param { Tag } target - insert before this tag's first child
	 * @param { Number } len - how many child nodes to move
	 */
	function moveVirtual(tag, src, target, len) {
	  var el = tag._root, sib, i = 0
	  for (; i < len; i++) {
	    sib = el.nextSibling
	    src.insertBefore(el, target._root)
	    el = sib
	  }
	}
	
	/**
	 * Insert a new tag avoiding the insert for the conditional tags
	 * @param   {Boolean} isVirtual [description]
	 * @param   { Tag }  prevTag - tag instance used as reference to prepend our new tag
	 * @param   { Tag }  newTag - new tag to be inserted
	 * @param   { HTMLElement }  root - loop parent node
	 * @param   { Array }  tags - array containing the current tags list
	 * @param   { Function }  virtualFn - callback needed to move or insert virtual DOM
	 * @param   { Object } dom - DOM node we need to loop
	 */
	function insertTag(isVirtual, prevTag, newTag, root, tags, virtualFn, dom) {
	  if (isInStub(prevTag.root)) return
	  if (isVirtual) virtualFn(prevTag, root, newTag, dom.childNodes.length)
	  else root.insertBefore(prevTag.root, newTag.root) // #1374 some browsers reset selected here
	}
	
	
	/**
	 * Manage tags having the 'each'
	 * @param   { Object } dom - DOM node we need to loop
	 * @param   { Tag } parent - parent tag instance where the dom node is contained
	 * @param   { String } expr - string contained in the 'each' attribute
	 */
	function _each(dom, parent, expr) {
	
	  // remove the each property from the original tag
	  remAttr(dom, 'each')
	
	  var mustReorder = typeof getAttr(dom, 'no-reorder') !== T_STRING || remAttr(dom, 'no-reorder'),
	    tagName = getTagName(dom),
	    impl = __tagImpl[tagName] || { tmpl: getOuterHTML(dom) },
	    useRoot = SPECIAL_TAGS_REGEX.test(tagName),
	    root = dom.parentNode,
	    ref = document.createTextNode(''),
	    child = getTag(dom),
	    isOption = tagName.toLowerCase() === 'option', // the option tags must be treated differently
	    tags = [],
	    oldItems = [],
	    hasKeys,
	    isVirtual = dom.tagName == 'VIRTUAL'
	
	  // parse the each expression
	  expr = tmpl.loopKeys(expr)
	
	  // insert a marked where the loop tags will be injected
	  root.insertBefore(ref, dom)
	
	  // clean template code
	  parent.one('before-mount', function () {
	
	    // remove the original DOM node
	    dom.parentNode.removeChild(dom)
	    if (root.stub) root = parent.root
	
	  }).on('update', function () {
	    // get the new items collection
	    var items = tmpl(expr.val, parent),
	      // create a fragment to hold the new DOM nodes to inject in the parent tag
	      frag = document.createDocumentFragment()
	
	    // object loop. any changes cause full redraw
	    if (!isArray(items)) {
	      hasKeys = items || false
	      items = hasKeys ?
	        Object.keys(items).map(function (key) {
	          return mkitem(expr, key, items[key])
	        }) : []
	    }
	
	    // loop all the new items
	    var i = 0,
	      itemsLength = items.length
	
	    for (; i < itemsLength; i++) {
	      // reorder only if the items are objects
	      var
	        item = items[i],
	        _mustReorder = mustReorder && typeof item == T_OBJECT && !hasKeys,
	        oldPos = oldItems.indexOf(item),
	        pos = ~oldPos && _mustReorder ? oldPos : i,
	        // does a tag exist in this position?
	        tag = tags[pos]
	
	      item = !hasKeys && expr.key ? mkitem(expr, item, i) : item
	
	      // new tag
	      if (
	        !_mustReorder && !tag // with no-reorder we just update the old tags
	        ||
	        _mustReorder && !~oldPos || !tag // by default we always try to reorder the DOM elements
	      ) {
	
	        tag = new Tag(impl, {
	          parent: parent,
	          isLoop: true,
	          hasImpl: !!__tagImpl[tagName],
	          root: useRoot ? root : dom.cloneNode(),
	          item: item
	        }, dom.innerHTML)
	
	        tag.mount()
	
	        if (isVirtual) tag._root = tag.root.firstChild // save reference for further moves or inserts
	        // this tag must be appended
	        if (i == tags.length || !tags[i]) { // fix 1581
	          if (isVirtual)
	            addVirtual(tag, frag)
	          else frag.appendChild(tag.root)
	        }
	        // this tag must be insert
	        else {
	          insertTag(isVirtual, tag, tags[i], root, tags, addVirtual, dom)
	          oldItems.splice(i, 0, item)
	        }
	
	        tags.splice(i, 0, tag)
	        pos = i // handled here so no move
	      } else tag.update(item, true)
	
	      // reorder the tag if it's not located in its previous position
	      if (
	        pos !== i && _mustReorder &&
	        tags[i] // fix 1581 unable to reproduce it in a test!
	      ) {
	        // #closes 2040 PLEASE DON'T REMOVE IT!
	        // there are no tests for this feature
	        if (contains(items, oldItems[i]))
	          insertTag(isVirtual, tag, tags[i], root, tags, moveVirtual, dom)
	
	        // update the position attribute if it exists
	        if (expr.pos)
	          tag[expr.pos] = i
	        // move the old tag instance
	        tags.splice(i, 0, tags.splice(pos, 1)[0])
	        // move the old item
	        oldItems.splice(i, 0, oldItems.splice(pos, 1)[0])
	        // if the loop tags are not custom
	        // we need to move all their custom tags into the right position
	        if (!child && tag.tags) moveNestedTags(tag, i)
	      }
	
	      // cache the original item to use it in the events bound to this node
	      // and its children
	      tag._item = item
	      // cache the real parent tag internally
	      defineProperty(tag, '_parent', parent)
	    }
	
	    // remove the redundant tags
	    unmountRedundant(items, tags)
	
	    // insert the new nodes
	    root.insertBefore(frag, ref)
	    if (isOption) {
	
	      // #1374 FireFox bug in <option selected={expression}>
	      if (FIREFOX && !root.multiple) {
	        for (var n = 0; n < root.length; n++) {
	          if (root[n].__riot1374) {
	            root.selectedIndex = n  // clear other options
	            delete root[n].__riot1374
	            break
	          }
	        }
	      }
	    }
	
	    // set the 'tags' property of the parent tag
	    // if child is 'undefined' it means that we don't need to set this property
	    // for example:
	    // we don't need store the `myTag.tags['div']` property if we are looping a div tag
	    // but we need to track the `myTag.tags['child']` property looping a custom child node named `child`
	    if (child) parent.tags[tagName] = tags
	
	    // clone the items array
	    oldItems = items.slice()
	
	  })
	
	}
	/**
	 * Object that will be used to inject and manage the css of every tag instance
	 */
	var styleManager = (function(_riot) {
	
	  if (!window) return { // skip injection on the server
	    add: function () {},
	    inject: function () {}
	  }
	
	  var styleNode = (function () {
	    // create a new style element with the correct type
	    var newNode = mkEl('style')
	    setAttr(newNode, 'type', 'text/css')
	
	    // replace any user node or insert the new one into the head
	    var userNode = $('style[type=riot]')
	    if (userNode) {
	      if (userNode.id) newNode.id = userNode.id
	      userNode.parentNode.replaceChild(newNode, userNode)
	    }
	    else document.getElementsByTagName('head')[0].appendChild(newNode)
	
	    return newNode
	  })()
	
	  // Create cache and shortcut to the correct property
	  var cssTextProp = styleNode.styleSheet,
	    stylesToInject = ''
	
	  // Expose the style node in a non-modificable property
	  Object.defineProperty(_riot, 'styleNode', {
	    value: styleNode,
	    writable: true
	  })
	
	  /**
	   * Public api
	   */
	  return {
	    /**
	     * Save a tag style to be later injected into DOM
	     * @param   { String } css [description]
	     */
	    add: function(css) {
	      stylesToInject += css
	    },
	    /**
	     * Inject all previously saved tag styles into DOM
	     * innerHTML seems slow: http://jsperf.com/riot-insert-style
	     */
	    inject: function() {
	      if (stylesToInject) {
	        if (cssTextProp) cssTextProp.cssText += stylesToInject
	        else styleNode.innerHTML += stylesToInject
	        stylesToInject = ''
	      }
	    }
	  }
	
	})(riot)
	
	
	function parseNamedElements(root, tag, childTags, forceParsingNamed) {
	
	  walk(root, function(dom) {
	    if (dom.nodeType == 1) {
	      dom.isLoop = dom.isLoop ||
	                  (dom.parentNode && dom.parentNode.isLoop || getAttr(dom, 'each'))
	                    ? 1 : 0
	
	      // custom child tag
	      if (childTags) {
	        var child = getTag(dom)
	
	        if (child && !dom.isLoop)
	          childTags.push(initChildTag(child, {root: dom, parent: tag}, dom.innerHTML, tag))
	      }
	
	      if (!dom.isLoop || forceParsingNamed)
	        setNamed(dom, tag, [])
	    }
	
	  })
	
	}
	
	function parseExpressions(root, tag, expressions) {
	
	  function addExpr(dom, val, extra) {
	    if (tmpl.hasExpr(val)) {
	      expressions.push(extend({ dom: dom, expr: val }, extra))
	    }
	  }
	
	  walk(root, function(dom) {
	    var type = dom.nodeType,
	      attr
	
	    // text node
	    if (type == 3 && dom.parentNode.tagName != 'STYLE') addExpr(dom, dom.nodeValue)
	    if (type != 1) return
	
	    /* element */
	
	    // loop
	    attr = getAttr(dom, 'each')
	
	    if (attr) { _each(dom, tag, attr); return false }
	
	    // attribute expressions
	    each(dom.attributes, function(attr) {
	      var name = attr.name,
	        bool = name.split('__')[1]
	
	      addExpr(dom, attr.value, { attr: bool || name, bool: bool })
	      if (bool) { remAttr(dom, name); return false }
	
	    })
	
	    // skip custom tags
	    if (getTag(dom)) return false
	
	  })
	
	}
	function Tag(impl, conf, innerHTML) {
	
	  var self = riot.observable(this),
	    opts = inherit(conf.opts) || {},
	    parent = conf.parent,
	    isLoop = conf.isLoop,
	    hasImpl = conf.hasImpl,
	    item = cleanUpData(conf.item),
	    expressions = [],
	    childTags = [],
	    root = conf.root,
	    tagName = root.tagName.toLowerCase(),
	    attr = {},
	    propsInSyncWithParent = [],
	    dom
	
	  // only call unmount if we have a valid __tagImpl (has name property)
	  if (impl.name && root._tag) root._tag.unmount(true)
	
	  // not yet mounted
	  this.isMounted = false
	  root.isLoop = isLoop
	
	  // keep a reference to the tag just created
	  // so we will be able to mount this tag multiple times
	  root._tag = this
	
	  // create a unique id to this tag
	  // it could be handy to use it also to improve the virtual dom rendering speed
	  defineProperty(this, '_riot_id', ++__uid) // base 1 allows test !t._riot_id
	
	  extend(this, { parent: parent, root: root, opts: opts}, item)
	  // protect the "tags" property from being overridden
	  defineProperty(this, 'tags', {})
	
	  // grab attributes
	  each(root.attributes, function(el) {
	    var val = el.value
	    // remember attributes with expressions only
	    if (tmpl.hasExpr(val)) attr[el.name] = val
	  })
	
	  dom = mkdom(impl.tmpl, innerHTML, isLoop)
	
	  // options
	  function updateOpts() {
	    var ctx = hasImpl && isLoop ? self : parent || self
	
	    // update opts from current DOM attributes
	    each(root.attributes, function(el) {
	      if (el.name in attr) return
	      var val = el.value
	      opts[toCamel(el.name)] = tmpl.hasExpr(val) ? tmpl(val, ctx) : val
	    })
	    // recover those with expressions
	    each(Object.keys(attr), function(name) {
	      opts[toCamel(name)] = tmpl(attr[name], ctx)
	    })
	  }
	
	  function normalizeData(data) {
	    for (var key in item) {
	      if (typeof self[key] !== T_UNDEF && isWritable(self, key))
	        self[key] = data[key]
	    }
	  }
	
	  function inheritFrom(target) {
	    each(Object.keys(target), function(k) {
	      // some properties must be always in sync with the parent tag
	      var mustSync = !RESERVED_WORDS_BLACKLIST.test(k) && contains(propsInSyncWithParent, k)
	
	      if (typeof self[k] === T_UNDEF || mustSync) {
	        // track the property to keep in sync
	        // so we can keep it updated
	        if (!mustSync) propsInSyncWithParent.push(k)
	        self[k] = target[k]
	      }
	    })
	  }
	
	  /**
	   * Update the tag expressions and options
	   * @param   { * }  data - data we want to use to extend the tag properties
	   * @param   { Boolean } isInherited - is this update coming from a parent tag?
	   * @returns { self }
	   */
	  defineProperty(this, 'update', function(data, isInherited) {
	
	    // make sure the data passed will not override
	    // the component core methods
	    data = cleanUpData(data)
	    // inherit properties from the parent in loop
	    if (isLoop) {
	      inheritFrom(self.parent)
	    }
	    // normalize the tag properties in case an item object was initially passed
	    if (data && isObject(item)) {
	      normalizeData(data)
	      item = data
	    }
	    extend(self, data)
	    updateOpts()
	    self.trigger('update', data)
	    update(expressions, self)
	
	    // the updated event will be triggered
	    // once the DOM will be ready and all the re-flows are completed
	    // this is useful if you want to get the "real" root properties
	    // 4 ex: root.offsetWidth ...
	    if (isInherited && self.parent)
	      // closes #1599
	      self.parent.one('updated', function() { self.trigger('updated') })
	    else rAF(function() { self.trigger('updated') })
	
	    return this
	  })
	
	  defineProperty(this, 'mixin', function() {
	    each(arguments, function(mix) {
	      var instance,
	        props = [],
	        obj
	
	      mix = typeof mix === T_STRING ? riot.mixin(mix) : mix
	
	      // check if the mixin is a function
	      if (isFunction(mix)) {
	        // create the new mixin instance
	        instance = new mix()
	      } else instance = mix
	
	      var proto = Object.getPrototypeOf(instance)
	
	      // build multilevel prototype inheritance chain property list
	      do props = props.concat(Object.getOwnPropertyNames(obj || instance))
	      while (obj = Object.getPrototypeOf(obj || instance))
	
	      // loop the keys in the function prototype or the all object keys
	      each(props, function(key) {
	        // bind methods to self
	        // allow mixins to override other properties/parent mixins
	        if (key != 'init') {
	          // check for getters/setters
	          var descriptor = Object.getOwnPropertyDescriptor(instance, key) || Object.getOwnPropertyDescriptor(proto, key)
	          var hasGetterSetter = descriptor && (descriptor.get || descriptor.set)
	
	          // apply method only if it does not already exist on the instance
	          if (!self.hasOwnProperty(key) && hasGetterSetter) {
	            Object.defineProperty(self, key, descriptor)
	          } else {
	            self[key] = isFunction(instance[key]) ?
	              instance[key].bind(self) :
	              instance[key]
	          }
	        }
	      })
	
	      // init method will be called automatically
	      if (instance.init) instance.init.bind(self)()
	    })
	    return this
	  })
	
	  defineProperty(this, 'mount', function() {
	
	    updateOpts()
	
	    // add global mixins
	    var globalMixin = riot.mixin(GLOBAL_MIXIN)
	
	    if (globalMixin)
	      for (var i in globalMixin)
	        if (globalMixin.hasOwnProperty(i))
	          self.mixin(globalMixin[i])
	
	    // children in loop should inherit from true parent
	    if (self._parent && self._parent.root.isLoop) {
	      inheritFrom(self._parent)
	    }
	
	    // initialiation
	    if (impl.fn) impl.fn.call(self, opts)
	
	    // parse layout after init. fn may calculate args for nested custom tags
	    parseExpressions(dom, self, expressions)
	
	    // mount the child tags
	    toggle(true)
	
	    // update the root adding custom attributes coming from the compiler
	    // it fixes also #1087
	    if (impl.attrs)
	      walkAttributes(impl.attrs, function (k, v) { setAttr(root, k, v) })
	    if (impl.attrs || hasImpl)
	      parseExpressions(self.root, self, expressions)
	
	    if (!self.parent || isLoop) self.update(item)
	
	    // internal use only, fixes #403
	    self.trigger('before-mount')
	
	    if (isLoop && !hasImpl) {
	      // update the root attribute for the looped elements
	      root = dom.firstChild
	    } else {
	      while (dom.firstChild) root.appendChild(dom.firstChild)
	      if (root.stub) root = parent.root
	    }
	
	    defineProperty(self, 'root', root)
	
	    // parse the named dom nodes in the looped child
	    // adding them to the parent as well
	    if (isLoop)
	      parseNamedElements(self.root, self.parent, null, true)
	
	    // if it's not a child tag we can trigger its mount event
	    if (!self.parent || self.parent.isMounted) {
	      self.isMounted = true
	      self.trigger('mount')
	    }
	    // otherwise we need to wait that the parent event gets triggered
	    else self.parent.one('mount', function() {
	      // avoid to trigger the `mount` event for the tags
	      // not visible included in an if statement
	      if (!isInStub(self.root)) {
	        self.parent.isMounted = self.isMounted = true
	        self.trigger('mount')
	      }
	    })
	  })
	
	
	  defineProperty(this, 'unmount', function(keepRootTag) {
	    var el = root,
	      p = el.parentNode,
	      ptag,
	      tagIndex = __virtualDom.indexOf(self)
	
	    self.trigger('before-unmount')
	
	    // remove this tag instance from the global virtualDom variable
	    if (~tagIndex)
	      __virtualDom.splice(tagIndex, 1)
	
	    if (p) {
	
	      if (parent) {
	        ptag = getImmediateCustomParentTag(parent)
	        // remove this tag from the parent tags object
	        // if there are multiple nested tags with same name..
	        // remove this element form the array
	        if (isArray(ptag.tags[tagName]))
	          each(ptag.tags[tagName], function(tag, i) {
	            if (tag._riot_id == self._riot_id)
	              ptag.tags[tagName].splice(i, 1)
	          })
	        else
	          // otherwise just delete the tag instance
	          ptag.tags[tagName] = undefined
	      }
	
	      else
	        while (el.firstChild) el.removeChild(el.firstChild)
	
	      if (!keepRootTag)
	        p.removeChild(el)
	      else {
	        // the riot-tag and the data-is attributes aren't needed anymore, remove them
	        remAttr(p, RIOT_TAG_IS)
	        remAttr(p, RIOT_TAG) // this will be removed in riot 3.0.0
	      }
	
	    }
	
	    if (this._virts) {
	      each(this._virts, function(v) {
	        if (v.parentNode) v.parentNode.removeChild(v)
	      })
	    }
	
	    self.trigger('unmount')
	    toggle()
	    self.off('*')
	    self.isMounted = false
	    delete root._tag
	
	  })
	
	  // proxy function to bind updates
	  // dispatched from a parent tag
	  function onChildUpdate(data) { self.update(data, true) }
	
	  function toggle(isMount) {
	
	    // mount/unmount children
	    each(childTags, function(child) { child[isMount ? 'mount' : 'unmount']() })
	
	    // listen/unlisten parent (events flow one way from parent to children)
	    if (!parent) return
	    var evt = isMount ? 'on' : 'off'
	
	    // the loop tags will be always in sync with the parent automatically
	    if (isLoop)
	      parent[evt]('unmount', self.unmount)
	    else {
	      parent[evt]('update', onChildUpdate)[evt]('unmount', self.unmount)
	    }
	  }
	
	
	  // named elements available for fn
	  parseNamedElements(dom, this, childTags)
	
	}
	/**
	 * Attach an event to a DOM node
	 * @param { String } name - event name
	 * @param { Function } handler - event callback
	 * @param { Object } dom - dom node
	 * @param { Tag } tag - tag instance
	 */
	function setEventHandler(name, handler, dom, tag) {
	
	  dom[name] = function(e) {
	
	    var ptag = tag._parent,
	      item = tag._item,
	      el
	
	    if (!item)
	      while (ptag && !item) {
	        item = ptag._item
	        ptag = ptag._parent
	      }
	
	    // cross browser event fix
	    e = e || window.event
	
	    // override the event properties
	    if (isWritable(e, 'currentTarget')) e.currentTarget = dom
	    if (isWritable(e, 'target')) e.target = e.srcElement
	    if (isWritable(e, 'which')) e.which = e.charCode || e.keyCode
	
	    e.item = item
	
	    // prevent default behaviour (by default)
	    if (handler.call(tag, e) !== true && !/radio|check/.test(dom.type)) {
	      if (e.preventDefault) e.preventDefault()
	      e.returnValue = false
	    }
	
	    if (!e.preventUpdate) {
	      el = item ? getImmediateCustomParentTag(ptag) : tag
	      el.update()
	    }
	
	  }
	
	}
	
	
	/**
	 * Insert a DOM node replacing another one (used by if- attribute)
	 * @param   { Object } root - parent node
	 * @param   { Object } node - node replaced
	 * @param   { Object } before - node added
	 */
	function insertTo(root, node, before) {
	  if (!root) return
	  root.insertBefore(before, node)
	  root.removeChild(node)
	}
	
	/**
	 * Update the expressions in a Tag instance
	 * @param   { Array } expressions - expression that must be re evaluated
	 * @param   { Tag } tag - tag instance
	 */
	function update(expressions, tag) {
	
	  each(expressions, function(expr, i) {
	
	    var dom = expr.dom,
	      attrName = expr.attr,
	      value = tmpl(expr.expr, tag),
	      parent = expr.parent || expr.dom.parentNode
	
	    if (expr.bool) {
	      value = !!value
	    } else if (value == null) {
	      value = ''
	    }
	
	    // #1638: regression of #1612, update the dom only if the value of the
	    // expression was changed
	    if (expr.value === value) {
	      return
	    }
	    expr.value = value
	
	    // textarea and text nodes has no attribute name
	    if (!attrName) {
	      // about #815 w/o replace: the browser converts the value to a string,
	      // the comparison by "==" does too, but not in the server
	      value += ''
	      // test for parent avoids error with invalid assignment to nodeValue
	      if (parent) {
	        // cache the parent node because somehow it will become null on IE
	        // on the next iteration
	        expr.parent = parent
	        if (parent.tagName === 'TEXTAREA') {
	          parent.value = value                    // #1113
	          if (!IE_VERSION) dom.nodeValue = value  // #1625 IE throws here, nodeValue
	        }                                         // will be available on 'updated'
	        else dom.nodeValue = value
	      }
	      return
	    }
	
	    // ~~#1612: look for changes in dom.value when updating the value~~
	    if (attrName === 'value') {
	      if (dom.value !== value) {
	        dom.value = value
	        setAttr(dom, attrName, value)
	      }
	      return
	    } else {
	      // remove original attribute
	      remAttr(dom, attrName)
	    }
	
	    // event handler
	    if (isFunction(value)) {
	      setEventHandler(attrName, value, dom, tag)
	
	    // if- conditional
	    } else if (attrName == 'if') {
	      var stub = expr.stub,
	        add = function() { insertTo(stub.parentNode, stub, dom) },
	        remove = function() { insertTo(dom.parentNode, dom, stub) }
	
	      // add to DOM
	      if (value) {
	        if (stub) {
	          add()
	          dom.inStub = false
	          // avoid to trigger the mount event if the tags is not visible yet
	          // maybe we can optimize this avoiding to mount the tag at all
	          if (!isInStub(dom)) {
	            walk(dom, function(el) {
	              if (el._tag && !el._tag.isMounted)
	                el._tag.isMounted = !!el._tag.trigger('mount')
	            })
	          }
	        }
	      // remove from DOM
	      } else {
	        stub = expr.stub = stub || document.createTextNode('')
	        // if the parentNode is defined we can easily replace the tag
	        if (dom.parentNode)
	          remove()
	        // otherwise we need to wait the updated event
	        else (tag.parent || tag).one('updated', remove)
	
	        dom.inStub = true
	      }
	    // show / hide
	    } else if (attrName === 'show') {
	      dom.style.display = value ? '' : 'none'
	
	    } else if (attrName === 'hide') {
	      dom.style.display = value ? 'none' : ''
	
	    } else if (expr.bool) {
	      dom[attrName] = value
	      if (value) setAttr(dom, attrName, attrName)
	      if (FIREFOX && attrName === 'selected' && dom.tagName === 'OPTION') {
	        dom.__riot1374 = value   // #1374
	      }
	
	    } else if (value === 0 || value && typeof value !== T_OBJECT) {
	      // <img src="{ expr }">
	      if (startsWith(attrName, RIOT_PREFIX) && attrName != RIOT_TAG) {
	        attrName = attrName.slice(RIOT_PREFIX.length)
	      }
	      setAttr(dom, attrName, value)
	    }
	
	  })
	
	}
	/**
	 * Specialized function for looping an array-like collection with `each={}`
	 * @param   { Array } els - collection of items
	 * @param   {Function} fn - callback function
	 * @returns { Array } the array looped
	 */
	function each(els, fn) {
	  var len = els ? els.length : 0
	
	  for (var i = 0, el; i < len; i++) {
	    el = els[i]
	    // return false -> current item was removed by fn during the loop
	    if (el != null && fn(el, i) === false) i--
	  }
	  return els
	}
	
	/**
	 * Detect if the argument passed is a function
	 * @param   { * } v - whatever you want to pass to this function
	 * @returns { Boolean } -
	 */
	function isFunction(v) {
	  return typeof v === T_FUNCTION || false   // avoid IE problems
	}
	
	/**
	 * Get the outer html of any DOM node SVGs included
	 * @param   { Object } el - DOM node to parse
	 * @returns { String } el.outerHTML
	 */
	function getOuterHTML(el) {
	  if (el.outerHTML) return el.outerHTML
	  // some browsers do not support outerHTML on the SVGs tags
	  else {
	    var container = mkEl('div')
	    container.appendChild(el.cloneNode(true))
	    return container.innerHTML
	  }
	}
	
	/**
	 * Set the inner html of any DOM node SVGs included
	 * @param { Object } container - DOM node where we will inject the new html
	 * @param { String } html - html to inject
	 */
	function setInnerHTML(container, html) {
	  if (typeof container.innerHTML != T_UNDEF) container.innerHTML = html
	  // some browsers do not support innerHTML on the SVGs tags
	  else {
	    var doc = new DOMParser().parseFromString(html, 'application/xml')
	    container.appendChild(
	      container.ownerDocument.importNode(doc.documentElement, true)
	    )
	  }
	}
	
	/**
	 * Checks wether a DOM node must be considered part of an svg document
	 * @param   { String }  name - tag name
	 * @returns { Boolean } -
	 */
	function isSVGTag(name) {
	  return ~SVG_TAGS_LIST.indexOf(name)
	}
	
	/**
	 * Detect if the argument passed is an object, exclude null.
	 * NOTE: Use isObject(x) && !isArray(x) to excludes arrays.
	 * @param   { * } v - whatever you want to pass to this function
	 * @returns { Boolean } -
	 */
	function isObject(v) {
	  return v && typeof v === T_OBJECT         // typeof null is 'object'
	}
	
	/**
	 * Remove any DOM attribute from a node
	 * @param   { Object } dom - DOM node we want to update
	 * @param   { String } name - name of the property we want to remove
	 */
	function remAttr(dom, name) {
	  dom.removeAttribute(name)
	}
	
	/**
	 * Convert a string containing dashes to camel case
	 * @param   { String } string - input string
	 * @returns { String } my-string -> myString
	 */
	function toCamel(string) {
	  return string.replace(/-(\w)/g, function(_, c) {
	    return c.toUpperCase()
	  })
	}
	
	/**
	 * Get the value of any DOM attribute on a node
	 * @param   { Object } dom - DOM node we want to parse
	 * @param   { String } name - name of the attribute we want to get
	 * @returns { String | undefined } name of the node attribute whether it exists
	 */
	function getAttr(dom, name) {
	  return dom.getAttribute(name)
	}
	
	/**
	 * Set any DOM/SVG attribute
	 * @param { Object } dom - DOM node we want to update
	 * @param { String } name - name of the property we want to set
	 * @param { String } val - value of the property we want to set
	 */
	function setAttr(dom, name, val) {
	  var xlink = XLINK_REGEX.exec(name)
	  if (xlink && xlink[1])
	    dom.setAttributeNS(XLINK_NS, xlink[1], val)
	  else
	    dom.setAttribute(name, val)
	}
	
	/**
	 * Detect the tag implementation by a DOM node
	 * @param   { Object } dom - DOM node we need to parse to get its tag implementation
	 * @returns { Object } it returns an object containing the implementation of a custom tag (template and boot function)
	 */
	function getTag(dom) {
	  return dom.tagName && __tagImpl[getAttr(dom, RIOT_TAG_IS) ||
	    getAttr(dom, RIOT_TAG) || dom.tagName.toLowerCase()]
	}
	/**
	 * Add a child tag to its parent into the `tags` object
	 * @param   { Object } tag - child tag instance
	 * @param   { String } tagName - key where the new tag will be stored
	 * @param   { Object } parent - tag instance where the new child tag will be included
	 */
	function addChildTag(tag, tagName, parent) {
	  var cachedTag = parent.tags[tagName]
	
	  // if there are multiple children tags having the same name
	  if (cachedTag) {
	    // if the parent tags property is not yet an array
	    // create it adding the first cached tag
	    if (!isArray(cachedTag))
	      // don't add the same tag twice
	      if (cachedTag !== tag)
	        parent.tags[tagName] = [cachedTag]
	    // add the new nested tag to the array
	    if (!contains(parent.tags[tagName], tag))
	      parent.tags[tagName].push(tag)
	  } else {
	    parent.tags[tagName] = tag
	  }
	}
	
	/**
	 * Move the position of a custom tag in its parent tag
	 * @param   { Object } tag - child tag instance
	 * @param   { String } tagName - key where the tag was stored
	 * @param   { Number } newPos - index where the new tag will be stored
	 */
	function moveChildTag(tag, tagName, newPos) {
	  var parent = tag.parent,
	    tags
	  // no parent no move
	  if (!parent) return
	
	  tags = parent.tags[tagName]
	
	  if (isArray(tags))
	    tags.splice(newPos, 0, tags.splice(tags.indexOf(tag), 1)[0])
	  else addChildTag(tag, tagName, parent)
	}
	
	/**
	 * Create a new child tag including it correctly into its parent
	 * @param   { Object } child - child tag implementation
	 * @param   { Object } opts - tag options containing the DOM node where the tag will be mounted
	 * @param   { String } innerHTML - inner html of the child node
	 * @param   { Object } parent - instance of the parent tag including the child custom tag
	 * @returns { Object } instance of the new child tag just created
	 */
	function initChildTag(child, opts, innerHTML, parent) {
	  var tag = new Tag(child, opts, innerHTML),
	    tagName = getTagName(opts.root),
	    ptag = getImmediateCustomParentTag(parent)
	  // fix for the parent attribute in the looped elements
	  tag.parent = ptag
	  // store the real parent tag
	  // in some cases this could be different from the custom parent tag
	  // for example in nested loops
	  tag._parent = parent
	
	  // add this tag to the custom parent tag
	  addChildTag(tag, tagName, ptag)
	  // and also to the real parent tag
	  if (ptag !== parent)
	    addChildTag(tag, tagName, parent)
	  // empty the child node once we got its template
	  // to avoid that its children get compiled multiple times
	  opts.root.innerHTML = ''
	
	  return tag
	}
	
	/**
	 * Loop backward all the parents tree to detect the first custom parent tag
	 * @param   { Object } tag - a Tag instance
	 * @returns { Object } the instance of the first custom parent tag found
	 */
	function getImmediateCustomParentTag(tag) {
	  var ptag = tag
	  while (!getTag(ptag.root)) {
	    if (!ptag.parent) break
	    ptag = ptag.parent
	  }
	  return ptag
	}
	
	/**
	 * Helper function to set an immutable property
	 * @param   { Object } el - object where the new property will be set
	 * @param   { String } key - object key where the new property will be stored
	 * @param   { * } value - value of the new property
	* @param   { Object } options - set the propery overriding the default options
	 * @returns { Object } - the initial object
	 */
	function defineProperty(el, key, value, options) {
	  Object.defineProperty(el, key, extend({
	    value: value,
	    enumerable: false,
	    writable: false,
	    configurable: true
	  }, options))
	  return el
	}
	
	/**
	 * Get the tag name of any DOM node
	 * @param   { Object } dom - DOM node we want to parse
	 * @returns { String } name to identify this dom node in riot
	 */
	function getTagName(dom) {
	  var child = getTag(dom),
	    namedTag = getAttr(dom, 'name'),
	    tagName = namedTag && !tmpl.hasExpr(namedTag) ?
	                namedTag :
	              child ? child.name : dom.tagName.toLowerCase()
	
	  return tagName
	}
	
	/**
	 * Extend any object with other properties
	 * @param   { Object } src - source object
	 * @returns { Object } the resulting extended object
	 *
	 * var obj = { foo: 'baz' }
	 * extend(obj, {bar: 'bar', foo: 'bar'})
	 * console.log(obj) => {bar: 'bar', foo: 'bar'}
	 *
	 */
	function extend(src) {
	  var obj, args = arguments
	  for (var i = 1; i < args.length; ++i) {
	    if (obj = args[i]) {
	      for (var key in obj) {
	        // check if this property of the source object could be overridden
	        if (isWritable(src, key))
	          src[key] = obj[key]
	      }
	    }
	  }
	  return src
	}
	
	/**
	 * Check whether an array contains an item
	 * @param   { Array } arr - target array
	 * @param   { * } item - item to test
	 * @returns { Boolean } Does 'arr' contain 'item'?
	 */
	function contains(arr, item) {
	  return ~arr.indexOf(item)
	}
	
	/**
	 * Check whether an object is a kind of array
	 * @param   { * } a - anything
	 * @returns {Boolean} is 'a' an array?
	 */
	function isArray(a) { return Array.isArray(a) || a instanceof Array }
	
	/**
	 * Detect whether a property of an object could be overridden
	 * @param   { Object }  obj - source object
	 * @param   { String }  key - object property
	 * @returns { Boolean } is this property writable?
	 */
	function isWritable(obj, key) {
	  var props = Object.getOwnPropertyDescriptor(obj, key)
	  return typeof obj[key] === T_UNDEF || props && props.writable
	}
	
	
	/**
	 * With this function we avoid that the internal Tag methods get overridden
	 * @param   { Object } data - options we want to use to extend the tag instance
	 * @returns { Object } clean object without containing the riot internal reserved words
	 */
	function cleanUpData(data) {
	  if (!(data instanceof Tag) && !(data && typeof data.trigger == T_FUNCTION))
	    return data
	
	  var o = {}
	  for (var key in data) {
	    if (!RESERVED_WORDS_BLACKLIST.test(key)) o[key] = data[key]
	  }
	  return o
	}
	
	/**
	 * Walk down recursively all the children tags starting dom node
	 * @param   { Object }   dom - starting node where we will start the recursion
	 * @param   { Function } fn - callback to transform the child node just found
	 */
	function walk(dom, fn) {
	  if (dom) {
	    // stop the recursion
	    if (fn(dom) === false) return
	    else {
	      dom = dom.firstChild
	
	      while (dom) {
	        walk(dom, fn)
	        dom = dom.nextSibling
	      }
	    }
	  }
	}
	
	/**
	 * Minimize risk: only zero or one _space_ between attr & value
	 * @param   { String }   html - html string we want to parse
	 * @param   { Function } fn - callback function to apply on any attribute found
	 */
	function walkAttributes(html, fn) {
	  var m,
	    re = /([-\w]+) ?= ?(?:"([^"]*)|'([^']*)|({[^}]*}))/g
	
	  while (m = re.exec(html)) {
	    fn(m[1].toLowerCase(), m[2] || m[3] || m[4])
	  }
	}
	
	/**
	 * Check whether a DOM node is in stub mode, useful for the riot 'if' directive
	 * @param   { Object }  dom - DOM node we want to parse
	 * @returns { Boolean } -
	 */
	function isInStub(dom) {
	  while (dom) {
	    if (dom.inStub) return true
	    dom = dom.parentNode
	  }
	  return false
	}
	
	/**
	 * Create a generic DOM node
	 * @param   { String } name - name of the DOM node we want to create
	 * @param   { Boolean } isSvg - should we use a SVG as parent node?
	 * @returns { Object } DOM node just created
	 */
	function mkEl(name, isSvg) {
	  return isSvg ?
	    document.createElementNS('http://www.w3.org/2000/svg', 'svg') :
	    document.createElement(name)
	}
	
	/**
	 * Shorter and fast way to select multiple nodes in the DOM
	 * @param   { String } selector - DOM selector
	 * @param   { Object } ctx - DOM node where the targets of our search will is located
	 * @returns { Object } dom nodes found
	 */
	function $$(selector, ctx) {
	  return (ctx || document).querySelectorAll(selector)
	}
	
	/**
	 * Shorter and fast way to select a single node in the DOM
	 * @param   { String } selector - unique dom selector
	 * @param   { Object } ctx - DOM node where the target of our search will is located
	 * @returns { Object } dom node found
	 */
	function $(selector, ctx) {
	  return (ctx || document).querySelector(selector)
	}
	
	/**
	 * Simple object prototypal inheritance
	 * @param   { Object } parent - parent object
	 * @returns { Object } child instance
	 */
	function inherit(parent) {
	  return Object.create(parent || null)
	}
	
	/**
	 * Get the name property needed to identify a DOM node in riot
	 * @param   { Object } dom - DOM node we need to parse
	 * @returns { String | undefined } give us back a string to identify this dom node
	 */
	function getNamedKey(dom) {
	  return getAttr(dom, 'id') || getAttr(dom, 'name')
	}
	
	/**
	 * Set the named properties of a tag element
	 * @param { Object } dom - DOM node we need to parse
	 * @param { Object } parent - tag instance where the named dom element will be eventually added
	 * @param { Array } keys - list of all the tag instance properties
	 */
	function setNamed(dom, parent, keys) {
	  // get the key value we want to add to the tag instance
	  var key = getNamedKey(dom),
	    isArr,
	    // add the node detected to a tag instance using the named property
	    add = function(value) {
	      // avoid to override the tag properties already set
	      if (contains(keys, key)) return
	      // check whether this value is an array
	      isArr = isArray(value)
	      // if the key was never set
	      if (!value)
	        // set it once on the tag instance
	        parent[key] = dom
	      // if it was an array and not yet set
	      else if (!isArr || isArr && !contains(value, dom)) {
	        // add the dom node into the array
	        if (isArr)
	          value.push(dom)
	        else
	          parent[key] = [value, dom]
	      }
	    }
	
	  // skip the elements with no named properties
	  if (!key) return
	
	  // check whether this key has been already evaluated
	  if (tmpl.hasExpr(key))
	    // wait the first updated event only once
	    parent.one('mount', function() {
	      key = getNamedKey(dom)
	      add(parent[key])
	    })
	  else
	    add(parent[key])
	
	}
	
	/**
	 * Faster String startsWith alternative
	 * @param   { String } src - source string
	 * @param   { String } str - test string
	 * @returns { Boolean } -
	 */
	function startsWith(src, str) {
	  return src.slice(0, str.length) === str
	}
	
	/**
	 * requestAnimationFrame function
	 * Adapted from https://gist.github.com/paulirish/1579671, license MIT
	 */
	var rAF = (function (w) {
	  var raf = w.requestAnimationFrame    ||
	            w.mozRequestAnimationFrame || w.webkitRequestAnimationFrame
	
	  if (!raf || /iP(ad|hone|od).*OS 6/.test(w.navigator.userAgent)) {  // buggy iOS6
	    var lastTime = 0
	
	    raf = function (cb) {
	      var nowtime = Date.now(), timeout = Math.max(16 - (nowtime - lastTime), 0)
	      setTimeout(function () { cb(lastTime = nowtime + timeout) }, timeout)
	    }
	  }
	  return raf
	
	})(window || {})
	
	/**
	 * Mount a tag creating new Tag instance
	 * @param   { Object } root - dom node where the tag will be mounted
	 * @param   { String } tagName - name of the riot tag we want to mount
	 * @param   { Object } opts - options to pass to the Tag instance
	 * @returns { Tag } a new Tag instance
	 */
	function mountTo(root, tagName, opts) {
	  var tag = __tagImpl[tagName],
	    // cache the inner HTML to fix #855
	    innerHTML = root._innerHTML = root._innerHTML || root.innerHTML
	
	  // clear the inner html
	  root.innerHTML = ''
	
	  if (tag && root) tag = new Tag(tag, { root: root, opts: opts }, innerHTML)
	
	  if (tag && tag.mount) {
	    tag.mount()
	    // add this tag to the virtualDom variable
	    if (!contains(__virtualDom, tag)) __virtualDom.push(tag)
	  }
	
	  return tag
	}
	/**
	 * Riot public api
	 */
	
	// share methods for other riot parts, e.g. compiler
	riot.util = { brackets: brackets, tmpl: tmpl }
	
	/**
	 * Create a mixin that could be globally shared across all the tags
	 */
	riot.mixin = (function() {
	  var mixins = {},
	    globals = mixins[GLOBAL_MIXIN] = {},
	    _id = 0
	
	  /**
	   * Create/Return a mixin by its name
	   * @param   { String }  name - mixin name (global mixin if object)
	   * @param   { Object }  mixin - mixin logic
	   * @param   { Boolean } g - is global?
	   * @returns { Object }  the mixin logic
	   */
	  return function(name, mixin, g) {
	    // Unnamed global
	    if (isObject(name)) {
	      riot.mixin('__unnamed_'+_id++, name, true)
	      return
	    }
	
	    var store = g ? globals : mixins
	
	    // Getter
	    if (!mixin) {
	      if (typeof store[name] === T_UNDEF) {
	        throw new Error('Unregistered mixin: ' + name)
	      }
	      return store[name]
	    }
	    // Setter
	    if (isFunction(mixin)) {
	      extend(mixin.prototype, store[name] || {})
	      store[name] = mixin
	    }
	    else {
	      store[name] = extend(store[name] || {}, mixin)
	    }
	  }
	
	})()
	
	/**
	 * Create a new riot tag implementation
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   html - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @returns { String } name/id of the tag just created
	 */
	riot.tag = function(name, html, css, attrs, fn) {
	  if (isFunction(attrs)) {
	    fn = attrs
	    if (/^[\w\-]+\s?=/.test(css)) {
	      attrs = css
	      css = ''
	    } else attrs = ''
	  }
	  if (css) {
	    if (isFunction(css)) fn = css
	    else styleManager.add(css)
	  }
	  name = name.toLowerCase()
	  __tagImpl[name] = { name: name, tmpl: html, attrs: attrs, fn: fn }
	  return name
	}
	
	/**
	 * Create a new riot tag implementation (for use by the compiler)
	 * @param   { String }   name - name/id of the new riot tag
	 * @param   { String }   html - tag template
	 * @param   { String }   css - custom tag css
	 * @param   { String }   attrs - root tag attributes
	 * @param   { Function } fn - user function
	 * @returns { String } name/id of the tag just created
	 */
	riot.tag2 = function(name, html, css, attrs, fn) {
	  if (css) styleManager.add(css)
	  //if (bpair) riot.settings.brackets = bpair
	  __tagImpl[name] = { name: name, tmpl: html, attrs: attrs, fn: fn }
	  return name
	}
	
	/**
	 * Mount a tag using a specific tag implementation
	 * @param   { String } selector - tag DOM selector
	 * @param   { String } tagName - tag implementation name
	 * @param   { Object } opts - tag logic
	 * @returns { Array } new tags instances
	 */
	riot.mount = function(selector, tagName, opts) {
	
	  var els,
	    allTags,
	    tags = []
	
	  // helper functions
	
	  function addRiotTags(arr) {
	    var list = ''
	    each(arr, function (e) {
	      if (!/[^-\w]/.test(e)) {
	        e = e.trim().toLowerCase()
	        list += ',[' + RIOT_TAG_IS + '="' + e + '"],[' + RIOT_TAG + '="' + e + '"]'
	      }
	    })
	    return list
	  }
	
	  function selectAllTags() {
	    var keys = Object.keys(__tagImpl)
	    return keys + addRiotTags(keys)
	  }
	
	  function pushTags(root) {
	    if (root.tagName) {
	      var riotTag = getAttr(root, RIOT_TAG_IS) || getAttr(root, RIOT_TAG)
	
	      // have tagName? force riot-tag to be the same
	      if (tagName && riotTag !== tagName) {
	        riotTag = tagName
	        setAttr(root, RIOT_TAG_IS, tagName)
	        setAttr(root, RIOT_TAG, tagName) // this will be removed in riot 3.0.0
	      }
	      var tag = mountTo(root, riotTag || root.tagName.toLowerCase(), opts)
	
	      if (tag) tags.push(tag)
	    } else if (root.length) {
	      each(root, pushTags)   // assume nodeList
	    }
	  }
	
	  // ----- mount code -----
	
	  // inject styles into DOM
	  styleManager.inject()
	
	  if (isObject(tagName)) {
	    opts = tagName
	    tagName = 0
	  }
	
	  // crawl the DOM to find the tag
	  if (typeof selector === T_STRING) {
	    if (selector === '*')
	      // select all the tags registered
	      // and also the tags found with the riot-tag attribute set
	      selector = allTags = selectAllTags()
	    else
	      // or just the ones named like the selector
	      selector += addRiotTags(selector.split(/, */))
	
	    // make sure to pass always a selector
	    // to the querySelectorAll function
	    els = selector ? $$(selector) : []
	  }
	  else
	    // probably you have passed already a tag or a NodeList
	    els = selector
	
	  // select all the registered and mount them inside their root elements
	  if (tagName === '*') {
	    // get all custom tags
	    tagName = allTags || selectAllTags()
	    // if the root els it's just a single tag
	    if (els.tagName)
	      els = $$(tagName, els)
	    else {
	      // select all the children for all the different root elements
	      var nodeList = []
	      each(els, function (_el) {
	        nodeList.push($$(tagName, _el))
	      })
	      els = nodeList
	    }
	    // get rid of the tagName
	    tagName = 0
	  }
	
	  pushTags(els)
	
	  return tags
	}
	
	/**
	 * Update all the tags instances created
	 * @returns { Array } all the tags instances
	 */
	riot.update = function() {
	  return each(__virtualDom, function(tag) {
	    tag.update()
	  })
	}
	
	/**
	 * Export the Virtual DOM
	 */
	riot.vdom = __virtualDom
	
	/**
	 * Export the Tag constructor
	 */
	riot.Tag = Tag
	  // support CommonJS, AMD & browser
	  /* istanbul ignore next */
	  if (typeof exports === T_OBJECT)
	    module.exports = riot
	  else if ("function" === T_FUNCTION && typeof __webpack_require__(41) !== T_UNDEF)
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return riot }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else
	    window.riot = riot
	
	})(typeof window != 'undefined' ? window : void 0);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * analytics module (Wrapper around iStats)
	 * @author Ardeshir Eshghi
	 *
	 */
	
	var istats = void 0;
	
	var Utils = __webpack_require__(4);
	
	var utils = new Utils();
	
	if (window.require) {
	    window.require(['istats-1'], function (istatsImport) {
	        istats = istatsImport;
	        console.info('iStats setup.');
	    });
	}
	
	var alreadyLoggedNotifications = [];
	
	module.exports = {
	    /**
	     * @param {Object} trackings Key value pair of linkType: options
	     */
	    track: function track(trackings) {
	        utils.each(trackings, function (properties, linkType) {
	            istats.track(linkType, properties);
	        });
	
	        return this;
	    },
	
	
	    /**
	     * Adds a new action handler for the actionName
	     * @param {string} actionName
	     * @param {string} istatsName
	     */
	    log: function log(actionType, actionName, options) {
	        if (istats) {
	            istats.log(actionType, actionName, options);
	        } else {
	            console.error('iStats not setup.');
	        }
	    },
	    serialiseTopic: function serialiseTopic(topic) {
	        var serialisedTopic = void 0;
	
	        serialisedTopic = topic.slice(0, 5).join('!').replace(/urn:bbc:/g, '').replace(/:/g, '-');
	        serialisedTopic = topic.length > 5 ? serialisedTopic.concat('!more than 5') : serialisedTopic;
	
	        return serialisedTopic;
	    },
	    logNewNotifications: function logNewNotifications(list, mainApp) {
	        var _this = this;
	
	        if (mainApp.getDrawerState() === 'shown') {
	            console.log('Checking for new notifications to log');
	
	            list.forEach(function (item) {
	                if (item.status === 'new' && !(alreadyLoggedNotifications.indexOf(item.id) !== -1)) {
	                    _this.log('seen', 'notifications-item', {
	                        notifications_id: item.id,
	                        notifications_state: 'blueDot',
	                        notifications_priority: (item.priority || 'normal').toLowerCase(),
	                        notifications_product: item.product.toLowerCase(),
	                        notifications_type: item.type.toLowerCase(),
	                        notifications_title: item.notification.title,
	                        topic_name: _this.serialiseTopic(item.topic)
	                    });
	
	                    alreadyLoggedNotifications.push(item.id);
	                }
	            });
	        }
	    }
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__idcta__ = __webpack_require__(9);
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	var notificationsAnalytics = __webpack_require__(1);
	var request = __webpack_require__(8);
	var config = __webpack_require__(3);
	
	var data = void 0;
	var defaultProducts = ['IPLAYER', 'MUSIC'];
	var friendlyProductNames = {
	    IPLAYER: 'iPlayer',
	    MUSIC: 'Music'
	};
	
	var subscriptionDomains = ['tv', 'music', 'radio', 'e2etest'];
	
	var readFilter = __webpack_require__(11);
	
	function checkStatus(response) {
	    if (response.status >= 200 && response.status < 400) {
	        return response;
	    }
	
	    var error = new Error('HTTP request failed ' + response.statusText);
	    error.response = response;
	    throw error;
	}
	
	module.exports = {
	    friendlyProductNames: friendlyProductNames,
	
	    get: function get() {
	        return data;
	    },
	    filterSubscriptionDomains: function filterSubscriptionDomains(i) {
	        if (!i.topic) {
	            return false;
	        }
	
	        var urn = i.topic.split(':');
	
	        if (urn[0] === 'urn' && urn[1] === 'bbc' && urn[2]) {
	            return subscriptionDomains.indexOf(urn[2]) !== -1;
	        }
	
	        return false;
	    },
	    fetch: function fetch() {
	        var _this = this;
	
	        var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (refresh === false && data) {
	            console.log('Fetching preferences from local cache');
	            return Promise.resolve(data);
	        }
	
	        console.log('Fetching preferences');
	        return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__idcta__.refreshToken().catch(function (err) {
	            notificationsAnalytics.log('error-refresh-token', 'notifications-error');
	            console.log('Preferences error');
	            throw err;
	        }).then(function () {
	            return request(config.env.preferencesUrls.get, {
	                credentials: 'include'
	            });
	        }).catch(function (err) {
	            console.log('Preferences error');
	            throw err;
	        }).then(function (json) {
	            data = json;
	            console.log('Returned preferences', data);
	
	            if (data.key) {
	                throw new Error(data);
	            }
	
	            if (!data.preferences) {
	                data.preferences = {
	                    readFilter: typeof readFilter.filter !== 'undefined' ? JSON.stringify(readFilter.getCleanArray()) : null
	                };
	            }
	
	            if (!data.preferences.productsEnabled) {
	                data.preferences.productsEnabled = defaultProducts.map(function (product) {
	                    // eslint-disable-line
	                    return { product: product, enabled: true };
	                });
	            }
	
	            console.log('Fetched preferences', data);
	            if (data.subscriptions) {
	                data.subscriptions = data.subscriptions.filter(_this.filterSubscriptionDomains);
	            }
	
	            return data;
	        });
	    },
	    set: function set(newData) {
	        var _this2 = this;
	
	        if (!data) {
	            return false;
	        }
	
	        var mergedPrefs = _extends(data.preferences || {}, newData.preferences);
	        data.preferences = mergedPrefs;
	        delete data.preferences.lastRead;
	        delete data.preferences.currentDateTime;
	
	        console.log('Merged prefs', mergedPrefs);
	        console.log('Setting data', data);
	
	        console.log('Preference set idcta object', /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__idcta__);
	
	        return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__idcta__.refreshToken().catch(function (err) {
	            throw err;
	        }).then(function () {
	            return fetch(config.env.preferencesUrls.postPreference, {
	                method: 'POST',
	                credentials: 'include',
	                headers: {
	                    Accept: '*/*',
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify(data.preferences)
	            });
	        }).then(checkStatus).catch(function (err) {
	            throw err;
	        }).then(function () {
	            delete data.preferences.onboardingFlag;
	            _this2.fetch();
	        });
	    },
	    updateRead: function updateRead() {
	        var lastReadFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        return this.set({
	            preferences: {
	                readFilter: typeof readFilter.filter !== 'undefined' ? JSON.stringify(readFilter.getCleanArray()) : null,
	                lastReadFlag: lastReadFlag
	            }
	        });
	    },
	    countActiveSubscriptions: function countActiveSubscriptions() {
	        var counter = 0;
	
	        if (data.subscriptions) {
	            data.subscriptions.forEach(function (item) {
	                if (item.enabled) {
	                    counter++;
	                }
	            });
	        }
	
	        return counter;
	    },
	    updateUserOnBoarding: function updateUserOnBoarding(cb) {
	        var newData = data.preferences || {};
	
	        if (!newData) {
	            newData = {
	                lastReadFlag: true,
	                productsEnabled: [],
	                readFilter: readFilter.getCleanArray()
	            };
	
	            defaultProducts.forEach(function (product) {
	                newData.productsEnabled.push({ product: product, enabled: true });
	            });
	        }
	
	        newData.hasOnboarded = true;
	        newData.onboardingFlag = true;
	        newData.lastReadFlag = true;
	        this.set(data).then(cb).catch(function (err) {
	            cb(err);
	            throw err;
	        });
	    }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	// env=live
	/* eslint-disable */
	
	var env = {
	    'feedBaseUrl': '//notifications.files.bbci.co.uk/',
	    'feedAggregatedInitialFeed': 'latest.json',
	    'feedTopicInitialFeed': 'latest.json',
	    'feedTopicMaxSubscriptions': 12,
	    'preferencesUrls': {
	        'get': 'https://preferences.notifications.api.bbc.co.uk/subscriptions',
	        'postPreference': 'https://preferences.notifications.api.bbc.co.uk/preference',
	        'postPreferenceRelay': 'https://preferences.notifications.api.bbc.co.uk/preference/relay',
	        'idcta': 'https://ssl.bbc.co.uk/idcta/init'
	    },
	    'under13s': {
	        'moreInfo': 'http://www.bbc.co.uk/usingthebbc/account/what-are-child-permissions/'
	    },
	    'idcta': {
	        'urls': {
	            'signin': 'https://ssl.bbc.co.uk/id/signin',
	            'register': 'https://ssl.bbc.co.uk/id/register'
	        }
	    },
	    'notificationsPollingInterval': 600000,
	    'preferencesPollingInterval': 600000,
	    'lockExpiry': 30000,
	    'cacheTimeout': 600000,
	    'visibleChunkAmount': 10,
	    'maxNotificationAge': 5
	};
	
	module.exports = { env: env };

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable */
	
	var utils = function utils() {};
	
	utils.prototype = {
	    handledParse: function handledParse(val, errorValue, onError) {
	        try {
	            return JSON.parse(val);
	        } catch (e) {
	
	            if (typeof onError === "function") onError();
	
	            return errorValue || null;
	        }
	    },
	    /**
	     * Extends objects
	     * By default shallow extend with true as the last argument is will do deep extend
	     * @return {Object}
	     */
	    extend: function extend() {
	
	        var args = Array.prototype.slice.call(arguments),
	            newObject,
	            keys,
	            lastArg,
	            cKey,
	            isDeep,
	            self = this;
	
	        // Ignore calls with no args
	        if (args.length === 0) return {};
	
	        // Check if extend is deep
	        lastArg = args[args.length - 1];
	        isDeep = lastArg === true;
	
	        // Remove the last arg if it 'true' or 'false'
	        if (typeof lastArg === 'boolean') args.pop();
	
	        function handleObjectItem(item, index) {
	            newObject[cKey][index] = !self.isObject(item) ? item : self.extend(newObject[cKey][index], item, isDeep);
	        }
	
	        // Go through the arguments
	        for (var i = 0; i < args.length; i++) {
	
	            // Get object keys
	            keys = self.keys(args[i]);
	
	            // Skip Objects with no keys
	            if (keys.length === 0) continue;
	
	            // Go through keys
	            for (var currentKey in args[i]) {
	
	                // Skip none property keys only for deep extend (Otherwise it will be an endless loop)
	                if (isDeep && !args[i].hasOwnProperty(currentKey)) continue;
	
	                newObject = newObject || {};
	
	                // When current argument key is array (Only on deep extend)
	                if (self.isArray(args[i][currentKey]) && isDeep) {
	
	                    if (typeof newObject[currentKey] !== 'undefined' && self.isArray(newObject[currentKey])) {
	
	                        cKey = currentKey;
	                        self.forEach(args[i][currentKey], handleObjectItem);
	                    } else {
	
	                        // When newObject currentKey is not yet defined or is none array we just set it to the copy
	                        // of the current key argument array (arguments on the same key better be consistent (no array object mix))
	                        newObject[currentKey] = args[i][currentKey].slice();
	                    }
	
	                    continue;
	                }
	
	                // When current argument key is object but not array (Only on deep extend)
	                if (self.isObject(args[i][currentKey]) && isDeep) {
	
	                    newObject[currentKey] = self.isObject(newObject[currentKey]) ? self.extend(newObject[currentKey], args[i][currentKey], isDeep) : self.extend(args[i][currentKey], isDeep);
	                    continue;
	                }
	
	                // On shallow extent or on deep extend when args[i][currentKey] is not object or array
	                if (args[i][currentKey] !== null && args[i][currentKey] !== undefined) newObject[currentKey] = args[i][currentKey];
	            }
	        }
	
	        return newObject;
	    },
	
	    forEach: function forEach(data, fn, that) {
	        that = that || null;
	        for (var i = 0, n = data.length; i < n; i++) {
	            if (i in data) {
	                fn.call(that, data[i], i, data);
	            }
	        }
	    },
	    truncate: function truncate(text) {
	        var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
	
	        var shortened = text.substring(0, maxLength + 1);
	
	        if (text.length > maxLength) {
	            if (shortened.indexOf(' ') == -1) {
	                return shortened.substring(0, shortened.length - 1).trim() + '...';
	            } else {
	                return shortened.substr(0, Math.min(shortened.length, shortened.lastIndexOf(' '))).trim() + '...';
	            }
	        } else {
	            return text;
	        }
	    },
	
	    each: function each(object, cb, context) {
	        context = context || null;
	        var keys;
	
	        if (!this.isObject(object)) return;
	
	        for (var name in object) {
	            if (object.hasOwnProperty(name)) {
	                cb.call(context, object[name], name);
	            }
	        }
	    },
	
	    bind: function bind(fn, context) {
	        if (typeof fn !== 'function') {
	            return;
	        }
	
	        if (fn.bind) {
	            return fn.bind(context);
	        }
	
	        return function () {
	            fn.apply(context, arguments);
	        };
	    },
	
	    isArray: function isArray(item) {
	        return Object.prototype.toString.call(item) === '[object Array]';
	    },
	
	    keys: function keys(obj) {
	        var keys = [];
	        for (var key in obj) {
	            if (obj.hasOwnProperty(key)) keys.push(key);
	        }
	
	        return keys;
	    },
	
	    isObject: function isObject(canBeObj) {
	        return (typeof canBeObj === 'undefined' ? 'undefined' : _typeof(canBeObj)) === "object" && canBeObj !== null;
	    }
	};
	
	module.exports = utils;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports,__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function(c,d){b(a.i18n=c,d)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):typeof exports=="object"?b(exports,require("riot")):b(a.i18n={},a.riot)})(this,function(a,b){function d(){this._entities={},this._default=c,this._language=this._default;var a=b.observable();this.on=a.on,this.off=a.off,this.trigger=a.trigger,this.on("lang",this.setLanguage)}var c="en";d.prototype.dictionary=function(a){this._entities=a},d.prototype.defaultLanguage=function(a){this._default=a},d.prototype.localise=function(a,b){function e(a,b,c,d){d=d||"",b=b||{},c=c||0;var f=a&&!a.length,g=f?Object.keys(a).length:0;if(f&&g>0){var h;for(h in a)d.split(".").length>c&&(d=d.split(".").splice(0,c).join(".")),d=c==0?h:d+"."+h,b=e(a[h],b,c+1,d)}else b[d]=a;return b}var c,d;this._entities[this._language]||(c=a),c||(d=e(this._entities[this._language]),d[a]?c=d[a]:c=a);if(b){var f=e(b),g;for(g in f)c=c.replace(new RegExp("{"+g+"}","g"),f[g])}return c},d.prototype.setLanguage=function(a){this._language=a||this._default,this.trigger("update")},d.prototype.getLanguage=function(){return this._language};var e=new d,f;for(f in e)a[f]=e[f];b.mixin("i18n",{i18n:a}),b.tag2("i1-8n",'<span name="localised"></span> <span name="original" class="original"><yield></yield></span>','i1-8n,[riot-tag="i1-8n"] { display: inline-block; } i1-8n .original,[riot-tag="i1-8n"] .original { display: none; }',"",function(a){this.mixin("i18n"),this.i18n.on("update",function(){this.update()}.bind(this)),this.on("mount update",function(){this.localised.innerHTML=this.i18n.localise(this.original.innerHTML)})})});

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable */
	
	/**
	 * Js browser compatible event module
	 * Inspired by John Resig: http://ejohn.org/blog/flexible-javascript-events/
	 *
	 */
	
	module.exports = {
	    isMatchingKeyEvent: function isMatchingKeyEvent(event, eventType, keys) {
	        if (event.type === eventType || eventType === 'any') {
	            var keyPressed = event.which || event.charCode;
	            if ((typeof keys === 'undefined' ? 'undefined' : _typeof(keys)) !== 'object') {
	                keys = [keys];
	            }
	            return keys.indexOf(keyPressed) !== -1;
	        }
	        return false;
	    },
	    addEvent: function addEvent(obj, type, fn) {
	        if (!obj) {
	            return;
	        }
	
	        if (obj.addEventListener) {
	            obj.addEventListener(type, fn, false);
	        } else {
	            obj['e' + type + fn] = fn;
	            obj[type + fn] = function () {
	                obj['e' + type + fn](window.event);
	            };
	            obj.attachEvent('on' + type, obj[type + fn]);
	        }
	    },
	    removeEvent: function removeEvent(obj, type, fn) {
	        if (!obj) {
	            return;
	        }
	
	        if (obj.removeEventListener) {
	            obj.removeEventListener(type, fn, false);
	        } else {
	            obj.detachEvent('on' + type, obj[type + fn]);
	            obj[type + fn] = null;
	        }
	    },
	    triggerEvent: function triggerEvent(obj, type, data, cancellable) {
	        var e = document.createEvent('Event');
	
	        cancellable = cancellable || false;
	
	        if (e.type === '') {
	            e.initEvent(type, true, cancellable);
	        }
	
	        e.data = data || {};
	
	        obj.dispatchEvent(e);
	    }
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	function find(array, predicate, context) {
	  if (typeof Array.prototype.find === 'function') {
	    return array.find(predicate, context);
	  }
	
	  context = context || this;
	  var length = array.length;
	  var i;
	
	  if (typeof predicate !== 'function') {
	    throw new TypeError(predicate + ' is not a function');
	  }
	
	  for (i = 0; i < length; i++) {
	    if (predicate.call(context, array[i], i, array)) {
	      return array[i];
	    }
	  }
	}
	
	module.exports = find;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(12);
	
	function isJSON(str) {
	    try {
	        JSON.parse(str);
	    } catch (e) {
	        return false;
	    }
	
	    return true;
	}
	
	function parseCallback(str) {
	    if (!str) {
	        return null;
	    }
	
	    if (isJSON(str)) {
	        return JSON.parse(str);
	    }
	
	    var newString = str;
	    newString = newString.substring(newString.indexOf('(') + 1);
	    newString = newString.substring(0, newString.length - 1);
	    return JSON.parse(newString);
	}
	
	function checkStatus(response) {
	    if (response.status >= 200 && response.status < 500) {
	        return response;
	    }
	
	    var error = new Error('HTTP request failed ' + response.statusText);
	    error.response = response;
	    throw error;
	}
	
	module.exports = function request(url, opts) {
	    var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var cacheKey = 'bbc-notifications-' + url;
	
	    console.info('Requesting', url);
	
	    if (cache) {
	        if (sessionStorage.getItem(cacheKey)) {
	            return new Promise(function (resolve) {
	                resolve(JSON.parse(sessionStorage.getItem(cacheKey)));
	            });
	        }
	    }
	
	    return fetch(url, opts).then(checkStatus).then(function (response) {
	        if (response.status === 404) {
	            return null;
	        }
	
	        return response.text();
	    }).then(function (text) {
	        var data = parseCallback(text);
	
	        if (cache && data) {
	            sessionStorage.setItem(cacheKey, JSON.stringify(data));
	        }
	
	        return data;
	    }).catch(function (err) {
	        console.error('Request failed', err);
	        throw err;
	    });
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony export */ exports["lib"] = lib;/* harmony export */ exports["refreshToken"] = refreshToken;'use strict';
	
	var libCache = void 0;
	
	function lib() {
	    return new Promise(function (resolve) {
	        if (libCache) {
	            resolve(libCache);
	        } else {
	            window.require(['idcta/idcta-1'], function (idctaRequire) {
	                libCache = idctaRequire;
	                resolve(libCache);
	            });
	        }
	    });
	}
	
	function refreshToken() {
	    console.log('Token refresh initiated');
	
	    return new Promise(function (resolve, reject) {
	        window.require(['idcta/idcta-1'], function (idctaRequire) {
	            console.log('IDCTA', idctaRequire);
	            idctaRequire.initiateTokenRefresh(undefined, undefined, true).then(function (response) {
	                console.log('Token refresh successful');
	                resolve(response);
	            }).catch(function (err) {
	                console.error('Token refresh failed', err);
	                reject(err);
	            });
	        });
	    });
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var request = __webpack_require__(8);
	var config = __webpack_require__(3);
	var UserPreferences = __webpack_require__(2);
	var find = __webpack_require__(7);
	
	var BaseCollection = function () {
	    function BaseCollection() {
	        _classCallCheck(this, BaseCollection);
	
	        this.MINIMUM_TO_DISPLAY = 8;
	
	        var pref = UserPreferences.get();
	        this.topics = pref.subscriptions.filter(function (item) {
	            return item.enabled;
	        });
	        this.topicKeys = this.topics.map(function (item) {
	            return item.topic;
	        });
	    }
	
	    _createClass(BaseCollection, [{
	        key: 'dedupeData',
	        value: function dedupeData(data) {
	            var ids = [];
	            var uniques = [];
	
	            data.forEach(function (i) {
	                if (ids.indexOf(i.id) >= 0) {
	                    return;
	                }
	
	                uniques.push(i);
	                ids.push(i.id);
	            });
	
	            return uniques;
	        }
	    }, {
	        key: 'filterData',
	        value: function filterData(data) {
	            var _this = this;
	
	            var pref = UserPreferences.get();
	            var productsEnabled = pref.preferences.productsEnabled.filter(function (p) {
	                return p.enabled;
	            }).map(function (p) {
	                return p.product;
	            });
	
	            this.topics = pref.subscriptions.filter(function (item) {
	                return item.enabled;
	            });
	            this.topicKeys = this.topics.map(function (item) {
	                return item.topic;
	            });
	
	            return data.filter(function (item) {
	                return (
	                    // Check we have enabled the notification product,
	                    // and we are subscribed to at least one topic in a notification
	                    productsEnabled.indexOf(item.product) !== -1 && item.topic.some(function (notificationTopic) {
	                        if (_this.topicKeys && _this.topicKeys.indexOf(notificationTopic) !== -1) {
	                            var topicSubscription = find(_this.topics, function (topic) {
	                                return topic.topic === notificationTopic;
	                            });
	
	                            // Check we subscribed to the topic before this notification was sent
	                            if (topicSubscription && new Date(item.creationTimestamp) > new Date(topicSubscription.lastSubscribed)) {
	                                return true;
	                            }
	                        }
	
	                        return false;
	                    })
	                );
	            });
	        }
	    }, {
	        key: 'loadData',
	        value: function loadData(folder) {
	            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest.json';
	
	            var url = 'https:' + config.env.feedBaseUrl + folder + '/' + page;
	            var now = new Date();
	
	            return request(url, {}, page !== 'latest.json').catch(function (err) {
	                throw err;
	            }).then(function (data) {
	                var list = [];
	                if (!data) {
	                    return { list: list, next: null, reachedEnd: true };
	                }
	
	                console.log('Base collection filtering data', data);
	
	                var reachedEnd = false;
	                if (data.notifications) {
	                    data.notifications.forEach(function (notif) {
	                        var notifDate = new Date(notif.creationTimestamp);
	
	                        var timeDiff = Math.abs(now.getTime() - notifDate.getTime());
	                        var daysOld = Math.floor(timeDiff / (1000 * 3600 * 24));
	
	                        if (daysOld >= config.env.maxNotificationAge) {
	                            reachedEnd = true;
	
	                            if (daysOld > config.env.maxNotificationAge) {
	                                return;
	                            }
	                        }
	
	                        list.push(notif);
	                    });
	                }
	
	                var next = data.next && data.next !== 'false' ? data.next : null;
	
	                return { list: list, next: next, reachedEnd: reachedEnd };
	            });
	        }
	    }]);
	
	    return BaseCollection;
	}();/* harmony export */ Object.defineProperty(exports, "BaseCollection", {configurable: false, enumerable: true, get: function() { return BaseCollection; }});

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BloomFilterManager__ = __webpack_require__(32);
	'use strict';
	
	
	
	module.exports = new /* harmony import */ __WEBPACK_IMPORTED_MODULE_0__BloomFilterManager__["BloomFilterManager"]('readFilter');

/***/ },
/* 12 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony export */ exports["get"] = get;/* harmony export */ exports["set"] = set;'use strict';
	
	/* eslint-disable prefer-template */
	
	function get(name) {
	    var value = '; ' + document.cookie;
	    var parts = value.split('; ' + name + '=');
	
	    if (parts.length === 2) {
	        return parts.pop().split(';').shift();
	    }
	
	    return undefined;
	}
	
	function set(name, domain) {
	    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
	    var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '1';
	
	    var date = new Date();
	    date.setFullYear(date.getFullYear() + 1);
	
	    document.cookie = encodeURIComponent(name) + '=' + value + '; expires=' + date.toGMTString() + (domain ? '; domain=' + domain : '') + (path ? '; path=' + path : '');
	}

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    "en": {
	        "copy": {
	            "noNotifications1": "No notifications right now. We'll let you know when something from your favourite programmes, artists and playlists is available for you.",
	            "noNotifications2": "If your notifications are turned off, you can always turn them back on. Just go to settings.",
	            "settings": "You can turn on and off any notifications you receive from iPlayer and Music. Turning notifications off will clear any you already have.",
	            "upsell": {
	                "title": "Never miss <br /> your favourites",
	                "body": "Get notifications about your favourite programmes, music and more."
	            },
	            "onboardingInfo1": "This is the place to get notifications about your favourite programmes, music, radio and more.",
	            "onboardingInfo2": "We'll give you notifications about anything already in your favourites, and anything new you add. You can manage your notifications any time in Settings.",
	            "onboardingInfo3": "Notifications are based on things you&#146;ve added…",
	            "onboardingInfo4": "… like TV and radio programmes, music artists and playlists.",
	            "ok": "OK, I'm in",
	            "showMeMore": "Show me more",
	            "error": {
	                "somethingWentWrong": "Sorry, something has gone wrong.",
	                "hubDisplay": "There's been an error and your notifications <br />can't be displayed at the moment. Please try again later.",
	                "hubUpdate": "Sorry, something has gone wrong.<br/>&nbsp;Your notifications could not be updated. Please try again later.",
	                "settingsDisplay": "There's been an error and your notifications settings <br />cannot be retrieved. Please try again later.",
	                "settingsUpdate": "Sorry, something has gone wrong.<br/>&nbsp;Your settings could not be updated. Please try again later.",
	                "onboarding": "There's been an error and we are unable to get you <br /> started with notifications. Please try again later."
	            },
	            "under13": {
	                "moreInfo": "Find out more about child permissions",
	                "parentId": {
	                    "title": "Want to hear about new stuff first?",
	                    "body": "To get notifications about stuff you love, you need to link BBC accounts with your parent or guardian and get their permission.",
	                    "button": "OK, ask for permission"
	                },
	                "linkPending": {
	                    "title": "You need permission from a parent or guardian to use notifications",
	                    "body": "We've sent them an email that tells them what to do. Ask them to check their inbox and follow the steps. To send a new email, visit your BBC account settings."
	                },
	                "permissionNotifications": {
	                    "title": "You need permission from a parent or guardian to use notifications",
	                    "body": "They can give permission by visiting the Child Permissions section in their BBC account settings."
	                },
	                "done": "All done! You can now use your notifications."
	            }
	        }
	    },
	    'cy': {
	        'Notifications': 'Hysbysiadau',
	        "Notifications Settings": "Gosodiadau'r Hysbysiadau",
	        "Settings": "Gosodiadau",
	        "Here's a notification about a new clip from BBC Music.": "Dyma hysbysiad am glip newydd gan BBC Music.",
	        "Here's a notification about a new episode in iPlayer.": "Dyma hysbysiad am bennod newydd yn iPlayer.",
	        "Back": "Nôl",
	        "day ago": "dydd yn ôl",
	        "days ago": "o ddyddiau yn ôl",
	        "hour ago": "awr yn ôl",
	        "hours ago": "awr yn ôl",
	        "minute ago": "munud yn ôl",
	        "minutes ago": "o funudau yn ôl",
	        "Yesterday": "Ddoe",
	        "10 minutes ago": "10 munud yn ôl",
	        "Just now": "Eiliad yn ôl",
	        "{product} Notifications": "Gosodiadau {product}",
	        "Sign in": "Mewngofnodi",
	        "or": "neu",
	        "Register": "Gofrestru",
	        "Notifications are based on things you've added…": "Mae hysbysiadau wedi eu seilio ar bethau rydych chi wedi eu hychwanegu…",
	        "… like TV and radio programmes, music artists and playlists.": "… fel rhaglenni teledu a radio, cerddoriaeth, artistiaid a rhestrau chwarae.",
	        "You'll get notifications when there's something new…": "Byddwch yn cael eich hysbysu pan mae yna rywbeth newydd…",
	        "… like an interview with a music artist you've added. Or an episode of a show you've added on iPlayer.": "… fel cyfweliad ag artist rydych chi wedi ei ychwanegu. Neu bennod o sioe rydych chi wedi ei ychwanegu ar iPlayer.",
	        "You're in charge": "Yn eich dwylo chi",
	        "Visit your Settings any time to manage your notifications.": "Ewch i'ch Gosodiadau unrhyw bryd i reoli eich hysbysiadau.",
	        "Load More": "Llwytho mwy",
	        "Close": "Cau",
	        "Go to Next slide": "Mynd i'r sleid nesaf",
	        "Go to Previous slide": "Mynd i'r sleid flaenorol",
	        "Go to slide 1": "Mynd i sleid 1",
	        "Go to slide 2": "Mynd i sleid 2",
	        "Go to slide 3": "Mynd i sleid 3",
	        "copy": {
	            "noNotifications1": "Dim hysbysiadau ar hyn o bryd. Byddwn ni'n gadael i chi wybod pan mae rhywbeth gan eich hoff raglenni, artistiaid a rhestrau chwarae ar gael i chi.",
	            "noNotifications2": "Os ydy'ch hysbysiadau wedi eu diffodd, gallwch eu troi nôl ymlaen. Ewch i'r gosodiadau.",
	            "settings": "Gallwch droi hysbysiadau iPlayer a Music ymlaen neu eu diffodd. Bydd diffodd yr hysbysiadau yn cael gwared ar y rhai rydych chi wedi eu cael yn barod.",
	            "upsell": {
	                "title": "Peidiwch â methu eich ffefrynnau",
	                "body": "Hysbysiadau am eich hoff rhaglenni, cerddoriaeth a mwy."
	            },
	            "onboardingInfo1": "Dyma'r lle i gael hysbysiadau am eich hoff raglenni, cerddoriaeth, radio a mwy. ",
	            "onboardingInfo2": "Byddwn yn eich hysbysu am unrhywbeth sydd yn eich ffefrynnau yn barod, ac unrhywbeth rydych chi'n ei ychwanegu. Gallwch reoli eich hysbysiadau unrhyw bryd yn y Gosodiadau.",
	            "onboardingInfo3": "Mae hysbysiadau wedi eu seilio ar bethau rydych chi wedi eu hychwanegu…",
	            "onboardingInfo4": "… fel rhaglenni teledu a radio, cerddoriaeth, artistiaid a rhestrau chwarae.",
	            "ok": "Iawn",
	            "showMeMore": "Dangos mwy",
	            "error": {
	                "somethingWentWrong": "Mae rhywbeth wedi mynd o'i le.",
	                "hubDisplay": "'Dyw hi ddim yn bosib dangos eich hysbysiadau ar hyn o bryd. Triwch eto nes ymlaen.",
	                "hubUpdate": "'Dyw eich hysbysiadau ddim yn gallu cael eu diweddaru. Triwch eto nes ymlaen.",
	                "settingsDisplay": "Mae yna broblem gyda'r gosodiadau ar hyn o bryd. Triwch eto nes ymlaen.",
	                "settingsUpdate": "'Dyw hi ddim yn bosib diweddaru eich gosodiadau. Triwch eto nes ymlaen.",
	                "onboarding": "'Dyw hi ddim yn bosib dechrau arni ar hyn o bryd. Triwch eto nes ymlaen."
	            },
	            "under13": {
	                "moreInfo": "Dysgu mwy am ganiatâd i blant",
	                "parentId": {
	                    "title": "Eisiau clywed am bethau newydd gyntaf?",
	                    "body": "Er mwyn derbyn hysbysiadau am dy hoff bethau, rhaid i ti gysylltu cyfrifon BBC gyda dy riant neu warchodwr er mwyn cael eu caniatâd.",
	                    "button": "Iawn, gofyn am ganiatâd"
	                },
	                "linkPending": {
	                    "title": "Rwyt ti angen caniatâd rhiant neu warchodwr i ddefnyddio hysbysiadau",
	                    "body": "Rydyn ni wedi anfon e-bost atyn nhw sy’n egluro beth i’w wneud. Maen nhw angen edrych yn eu mewnflwch a dilyn y cyfarwyddiadau. Er mwyn cael e-bost newydd, cer i osodiadau dy gyfrif BBC."
	                },
	                "permissionNotifications": {
	                    "title": "Rwyt ti angen caniatâd rhiant neu warchodwr i ddefnyddio hysbysiadau",
	                    "body": "Gallan nhw roi caniatâd drwy fynd i adran Caniatâd i Blant yng ngosodiadau eu cyfrif BBC."
	                },
	                "done": "Barod! Nawr galli di ddefnyddio dy hysbysiadau."
	            }
	        }
	    },
	    "gd": {
	        "Notifications": "Fiosan",
	        "Notifications Settings": "Seataidhean Fiosa",
	        "Settings": "Seataidhean",
	        "Here's a notification about a new clip from BBC Music.": "Seo fios mu chriomag ùr bho BBC Music.",
	        "Here's a notification about a new episode in iPlayer.": "Seo fios mu phrògram ùr ann an iPlayer.",
	        "Back": "Air ais",
	        "day ago": "latha air ais",
	        "days ago": "làithean air ais",
	        "hour ago": "uair air ais",
	        "hours ago": "uairean air ais",
	        "minute ago": "mhionaid air ais",
	        "minutes ago": "mionaidean air ais",
	        "Yesterday": "An-dè",
	        "10 minutes ago": "10 mionaidean air ais",
	        "Just now": "An-dràsta",
	        "{product} Notifications": "Fiosan {product}",
	        "Sign in": "Log a-steach",
	        "or": "no",
	        "Register": "Clàraich",
	        "Notifications are based on things you've added…": "Tha fiosan stèidhichte air rudan a chur thu ris...",
	        "… like TV and radio programmes, music artists and playlists.": "… mar phrògraman Tbh agus rèidio, luchd ciùil agus clàran-ciùil.",
	        "You'll get notifications when there's something new…": "Gheibh thu fiosan nuair a tha rudan ùra ann…",
	        "… like an interview with a music artist you've added. Or an episode of a show you've added on iPlayer.": "… mar agallamh le luchd ciùil a chur thu ris. No prògram a chur thu ris ann an iPlayer.",
	        "You're in charge": "'S tusa a tha os cionn chùisean!",
	        "Visit your Settings any time to manage your notifications.": "Thèid gu Seataidhean airson rian a chumail air d' fhiosan",
	        "Load More": "Faic tuilleadh",
	        "Close": "Dùin",
	        "Go to Next slide": "An ath slaighd",
	        "Go to Previous slide": "An slaighd roimhe",
	        "Go to slide 1": "Rach gu slaighd 1",
	        "Go to slide 2": "Rach gu slaighd 2",
	        "Go to slide 3": "Rach gu slaighd 3",
	        "copy": {
	            "noNotifications1": "Chan eil fiosan ann an-dràsta. Leigidh sinn fios nuair a bhios rudeigin ann bho na prògraman, luchd ciùil is clàran-ciùil as fheàrr leat.",
	            "noNotifications2": "Ma tha d’ fhiosan air an cur dheth, faodaidh tu an cur air a-rithist le bhith dol gu seataidhean.",
	            "settings": "Faodar brathan a tha thu a' faighinn bho iPlayer agus Music a chur air is dheth. Thèid an fheadhainn a th' agad mar-thà a dhubhadh às le bhith gan cuir dheth.",
	            "upsell": {
	                "title": "Na caill na rudan as fheàrr leat",
	                "body": "Faigh fiosan mu na prògraman 's an ceòl as fheàrr leat agus gu leòr eile."
	            },
	            "onboardingInfo1": "Seo far am faighear fiosan mu na prògraman 's an ceòl as fheàrr leat agus gu leòr eile.",
	            "onboardingInfo2": "Cuiridh sinn fiosan thugad mu na rudan a tha nad roghainnean agus rud sam bith eile a chuireas tu ris. Faodaidh tu rian a chumail air iad seo ann an Seataidhean.",
	            "onboardingInfo3": "Tha fiosan stèidhichte air rudan a chur thu ris...",
	            "onboardingInfo4": "… mar phrògraman Tbh agus rèidio, luchd ciùil agus clàran-ciùil.",
	            "ok": "Ceart",
	            "showMeMore": "Seall tuilleadh",
	            "error": {
	                "somethingWentWrong": "Duilich, tha rudeigin air a dhol ceàrr.",
	                "hubDisplay": "Chaidh rudeigin ceàrr is chan urrainnear d’ fhiosan a shealltainn an-dràsta. Feuch a-rithist.",
	                "hubUpdate": "Duilich, tha rudeigin air a dhol ceàrr. Cha b’ urrainnear d' fhiosan ùrachadh. Feuch a-rithist.",
	                "settingsDisplay": "Chaidh rudeigin ceàrr is chan fhaighear do sheataidhean fiosa. Feuch a-rithist.",
	                "settingsUpdate": "Duilich, tha rudeigin air a dhol ceàrr. Cha b’ urrainnear do sheataidhean ùrachadh. Feuch a-rithist.",
	                "onboarding": "Chaidh rudeigin ceàrr is chan fhaigh sinn air d’ fhiosan a chur an sàs. Feuch a-rithist."
	            },
	            "under13": {
	                "moreInfo": "Faigh a-mach tuilleadh mu cheadan cloinne",
	                "parentId": {
	                    "title": "Airson cluinntinn mu rudan ùra an toiseach?",
	                    "body": "Feumaidh tu cead fhaighinn bho do phàrant no do neach-cùraim agus do chunntas BBC a cheangal ris an fhear acasan airson fiosan fhaighinn mu na rudan a tha a’ còrdadh riut.",
	                    "button": "Ceart, iarr cead"
	                },
	                "linkPending": {
	                    "title": "Feumar cead fhaighinn bho phàrant no neach-cùraim airson fiosan a chleachdadh",
	                    "body": "Tha sinn air post-d a chur thuca le stiùireadh. Iarr orra sùil a thoirt air na puist-d aca agus na ceumannan a' leantainn. Tadhal air seataidhean cunntais a' BhBC airson post-d a chur air falbh."
	                },
	                "permissionNotifications": {
	                    "title": "Feumar cead fhaighinn bho phàrant no neach-cùraim airson fiosan a chleachdadh",
	                    "body": "Faodaidh iadsan cead a thoirt le bhith tadhal air Ceadan Chloinne ann an seataidhean cunntais a' BhBC."
	                },
	                "done": "Dèanta! Faodaidh tu na fiosan agad a chleachdadh."
	            }
	        }
	    },
	    "ga": {
	        "Notifications": "Fógraí",
	        "Notifications Settings": "Socruithe na bhFógraí",
	        "Settings": "Socruithe",
	        "Here's a notification about a new clip from BBC Music.": "Seo fógra faoi ghearrthóg úr ó BBC Music.",
	        "Here's a notification about a new episode in iPlayer.": "Seo fógra faoi eagrán úr ar iPlayer.",
	        "Back": "Siar",
	        "day ago": "lá ó shin",
	        "days ago": "lá ó shin",
	        "hour ago": "uair ó shin",
	        "hours ago": "uair ó shin",
	        "minute ago": "nóiméad ó shin",
	        "minutes ago": "nóiméad ó shin",
	        "Yesterday": "Inné",
	        "10 minutes ago": "10 mbomaite ó shin",
	        "Just now": "Díreach ansin",
	        "{product} Notifications": "Fógraí {product}",
	        "Sign in": "Sínigh isteach",
	        "or": "nó",
	        "Register": "Cláraigh",
	        "Notifications are based on things you've added…": "Tá fógraí bunaithe ar rudaí a chuir tú leis…",
	        "… like TV and radio programmes, music artists and playlists.": "… mar shampla, cláir TV, raidió, ceoltóirí agus seinnliostaí.",
	        "You'll get notifications when there's something new…": "Gheobhaidh tú fógraí nuair atá rudaí úra ann.",
	        "… like an interview with a music artist you've added. Or an episode of a show you've added on iPlayer.": "… ar nós agallaimh le ceoltóir a chuir tú leis, nó eagrán de chlár a chuir tú le iPlayer.",
	        "You're in charge": "Tá tú i gceannas!",
	        "Visit your Settings any time to manage your notifications.": "Tabhair cuairt ar do chuid Socruithe le go dtig leat smacht a choinneáil orthu.",
	        "Load More": "Lódáil tuilleadh",
	        "Close": "Druid",
	        "Go to Next slide": "Téigh go céad sleamhnán eile",
	        "Go to Previous slide": "Téigh go sleamhnán roimhe",
	        "Go to slide 1": "Téigh go sleamhnán 1",
	        "Go to slide 2": "Téigh go sleamhnán 2",
	        "Go to slide 3": "Téigh go sleamhnán 3",
	        "copy": {
	            "noNotifications1": "Níl fógraí ann faoi láthair. Beidh muid i dteagmháil leat má bhíonn rud éigin ar fáil a bhaineann leis na cláir, na ceoltóirí nó na seinnliostaí is ansa leat.",
	            "noNotifications2": "Má tá do chuid fógraí múchta, thig leat iad a chur air arís. Téigh go socruithe.",
	            "settings": "Thig leat fógraí ó iPlayer agus Music a chur air nó as. Glanfaidh tú na fógraí atá agat cheana féin má mhúchann tú iad.",
	            "upsell": {
	                "title": "Ná caill do chianáin riamh",
	                "body": "Aimsigh fógraí faoi do chianáin, do cheol agus níos mó."
	            },
	            "onboardingInfo1": "Is anseo a dtig leat fógraí a aimsiú faoi na cláir, faoin cheol, faoin raidió is ansa leat agus níos mó.",
	            "onboardingInfo2": "Cuirfidh muid fógraí ar fáil duit faoi rud ar bith atá i do chianáin cheana féin agus faoi rud ar bith úr a chuireann tú leo. Thig leat smacht a bheith agat ar do chuid fógraí am ar bith in Socruithe.",
	            "onboardingInfo3": "Tá fógraí bunaithe ar rudaí a chuir tú leis…",
	            "onboardingInfo4": "… mar shampla, cláir TV, raidió, ceoltóirí agus seinnliostaí.",
	            "ok": "Ceart go leor",
	            "showMeMore": "Taispeáin a thuilleadh",
	            "error": {
	                "somethingWentWrong": "Tá brón orainn, tá rud éigin cearr.",
	                "hubDisplay": "Tá rud éigin cearr agus ní féidir do chuid fógraí a fheiceáil faoi láthair. Triail arís níos moille, le do thoil.",
	                "hubUpdate": "Tá brón orainn, tá rud éigin cearr. Ní féidir do chuid fógraí a uasdátú. Triail arís níos moille, le do thoil.",
	                "settingsDisplay": "Tá fadhb le socruithe na bhfógraí s'agat agus níl fáil orthu. Triail arís níos moille, le do thoil.",
	                "settingsUpdate": "Tá brón orainn, tá rud éigin cearr. Ní féidir do chuid fógraí a uasdátú. Triail arís níos moille, le do thoil.",
	                "onboarding": "Tá fadhb éigin ann agus ní féidir do chuid fógraí a chur sa tsiúl. Triail arís níos moille, le do thoil."
	            },
	            "under13": {
	                "moreInfo": "Tuilleadh eolais ar cheadanna páistí",
	                "parentId": {
	                    "title": "Ar mhaith leat bheith ar an eolas faoin stuif úr ar dtús?",
	                    "body": "Le fógraí a fháil ar an stuif is ansa leat, beidh ort cuntais BBC a nascadh le do thuismitheoir nó le do chaomhnóir agus a c(h)ead a fháil.",
	                    "button": "Maith go leor, iarr cead."
	                },
	                "linkPending": {
	                    "title": "Tá cead tuismitheora nó caomhnóra de dhíth ort le fógraí a úsáid",
	                    "body": "Sheol muid ríomhphost chucu a insíonn dóibh cad é atá le déanamh. Iarr orthu a mbosca isteach a sheiceáil agus na céimeanna a leanúint. Le ríomhphost úr a sheoladh, tabhair cuairt ar shocruithe do chuntais BBC."
	                },
	                "permissionNotifications": {
	                    "title": "Tá cead tuismitheora nó caomhnóra de dhíth ort le fógraí a úsáid",
	                    "body": "Thig leo cead a thabhairt ach dul chuig Ceadanna Páistí i socruithe a c(h)untais BBC."
	                },
	                "done": "Déanta! Thig leat d’fhógraí a úsáid anois."
	            }
	        }
	    }
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony export */ exports["touchevents"] = touchevents;'use strict';
	
	var addedClass = [];
	
	function addBodyClass(id, val) {
	    if (document.documentElement.classList) {
	        if (!(addedClass.indexOf(id) !== -1)) {
	            document.documentElement.classList.add('n-' + (val ? '' : 'no-') + id);
	            addedClass.push(id);
	        }
	    }
	}
	
	function touchevents() {
	    var check = 'ontouchstart' in window;
	
	    addBodyClass('touchevents', check);
	
	    return check;
	}

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	(function () {
		var testObject = {};
	
		if (!(Object.setPrototypeOf || testObject.__proto__)) {
			var nativeGetPrototypeOf = Object.getPrototypeOf;
	
			Object.getPrototypeOf = function (object) {
				if (object.__proto__) {
					return object.__proto__;
				} else {
					return nativeGetPrototypeOf.call(Object, object);
				}
			};
		}
	})();

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-bell', '<a name="notificationLink" id="notification-link" class="js-notification-link animated three notifications-shown {swing: opts.alert, notifications-black-bell: opts.state.signedIn === true, notifications-grey-bell: opts.state.signedIn !== true}" href="#"> <span class="hidden-span" style="height: 1px; width: 1px; position: absolute; overflow: hidden; top: -10px;">Notifications</span> <div class="notification-link--triangle"></div> <div class="notification-link--triangle"></div> <span id="not-num" class="{\'new-notifications\': opts.alert}"></span> <span aria-live="polite" class="notification-link__live notification-link__live--js">{opts.alert ? this.getAlertText() : \'\'}</span> </a>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	this.on('mount', function () {
	    console.log('Bell mount', opts.state, opts.mainApp);
	
	    // Set notif icon. Needed for onboarding file.
	    opts.mainApp.setNotificationIcon();
	});
	
	this.getAlertText = function () {
	    var drawerState = _this.parent.opts.mainApp.getDrawerState();
	    return drawerState === 'hidden' ? 'New Notification. To view open the "Notification Panel" link.' : 'New Notification available.';
	};
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-drawer', '<bbc-notifications-error-banner if="{opts.error.inner && !opts.error.main}" type="{opts.error.inner}"></bbc-notifications-error-banner> <bbc-notifications-error-view if="{opts.error.main}" type="{opts.error.main}"></bbc-notifications-error-view> <div if="{!opts.error.main && opts.state}"> <bbc-notifications-signed-in-view if="{opts.state.signedIn === true}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" state="{opts.state}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}" load-onboarding="{this.loadOnboarding}" view="{opts.view}"></bbc-notifications-signed-in-view> <bbc-notifications-signed-out-view if="{opts.state.signedIn === false}" state="{opts.state}"></bbc-notifications-signed-out-view> </div>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	this.basePath = opts.mainApp.basePath;
	
	this.on('mount', function () {
	    // Create drawer holder
	    var drawerName = 'notifications';
	    var drawerContent = document.createElement('div');
	    drawerContent.className = 'orb-panel';
	    drawerContent.appendChild(_this.root);
	
	    // Move drawer into Orbit
	    opts.orb.addDrawer(drawerName, document.querySelector('.js-notification-link'), drawerContent, opts.componentApp.drawerStateChangedCallback);
	});
	
	this.on('updated', function () {
	    if (_this.updateFocus) {
	        console.log('Updating focus', _this.updateFocus);
	
	        var el = document.querySelector(_this.updateFocus);
	        if (el) {
	            el.focus();
	        }
	
	        _this.updateFocus = null;
	    }
	
	    opts.mainApp.updateDrawerHeight();
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-error-banner', '<section class="notification-error__container"> <div if="{opts.type == \'settings\'}" class="notifications-error--inner show" id="settings-error-inner"> <p class=" notifications-error--inner__body notifications-10/12"><i1-8n>copy.error.settingsUpdate</i1-8n></p> </p> <div class="notifications-error--inner__container"> <div aria-label="Close notification error message" class="notifications-error--inner__close" aria-action="close" onclick="{this.closeInner}">&nbsp;</div> </div> </div> </section>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	var notificationsAnalytics = __webpack_require__(1);
	
	this.closeInner = function () {
	    _this.parent.parent.error.inner = null;
	    _this.parent.parent.update();
	};
	
	this.on('mount', function () {
	    notificationsAnalytics.log('error4-settings-fail', 'notifications-error');
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-error-view', '<section class="notification-error__container"> <div if="{opts.type == \'hub\'}" class="notifications-error show" id="hub-error-main"> <div class="notifications-error__header"> <p class="notifications-error__header--text"><i1-8n>copy.error.somethingWentWrong</i1-8n></p> </div> <p class="notifications-pica notifications-error__body"><i1-8n>copy.error.hubDisplay</i1-8n></p> </div> <div if="{opts.type == \'settings\'}" class="notifications-error show" id="settings-error-main"> <div class="notifications-error__header"> <p class="notifications-error__header--text"><i1-8n>copy.error.somethingWentWrong</i1-8n></p> </div> <p class="notifications-pica notifications-error__body"><i1-8n>copy.error.settingsDisplay</i1-8n></p> <div class="notifications-error__back" aria-action="close"> <div class="notifications-error__back__arrow"> </div> <div class="notifications-error__back__text"><i1-8n>Back</i1-8n> </div> </div> </div> <div if="{opts.type == \'onboarding\'}" class="notifications-error show" id="onboarding-error-main"> <div class="notifications-error__header"> <p class="notifications-error__header--text"><i1-8n>copy.error.somethingWentWrong</i1-8n></p> </div> <p class="notifications-pica notifications-error__body"><i1-8n>copy.error.onboarding</i1-8n></p> </div> </section>', '', '', function(opts) {
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-home-view', '<header class="notifications__header notifications__header--js {\'shadowAdded\': shadowAdded}"> <h2 class="notification-title"><i1-8n>Notifications</i1-8n></h2> <ul class="notification-header-icons"> <li><a href="javascript:;" class="notifications__settings--js" onkeydown="{this.onSettingsKeydown}" onclick="{parent.openSettings}"><img class="setting-icon notifications-image" riot-src="{this.basePath + \'/svg/setting.svg\'}" alt="Settings"><span class="notifications-brevier"><i1-8n>Settings</i1-8n></span></a></li> </ul> </header> <div class="notification-panel" style="display: block;"> <bbc-notifications-list if="{opts.notifications.length}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}"></bbc-notifications-list> <div if="{!opts.notifications.length}" id="no-notifications" class="no-notifications"> <div class="noVariant--element"> <p class="notifications-long-primer"><i1-8n>copy.noNotifications1</i1-8n></p> <p class="notifications-long-primer"><i1-8n>copy.noNotifications2</i1-8n></p> </div> </div> </div>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	this.basePath = opts.mainApp.basePath;
	
	this.onSettingsKeydown = function (e) {
	    console.log('Settings press', e);
	    if (e.keyCode === 9 && e.shiftKey) {
	        // Tab backwards
	        var closeBtn = document.querySelector('.notifications-keyboard-access--close');
	
	        if (closeBtn) {
	            closeBtn.focus();
	            return false;
	        }
	
	        var lastNotif = document.querySelector('.notification-items .notification-item:last-child a');
	
	        if (lastNotif) {
	            lastNotif.focus();
	            return false;
	        }
	    } else if (e.keyCode === 13) {
	        // Enter
	        _this.updateFocus = '.notifications__settings__back-btn--js';
	    } else if (e.keyCode === 9 && !e.shiftKey) {
	        // Tab forwards
	        if (!document.querySelectorAll('bbc-notifications-list .notification-item').length) {
	            _this.update({ showKeyboardAccess: true });
	        }
	    }
	
	    return true;
	};
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-idcta-html', '<span></span>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	// Riot does not have a syntax for rendering raw, unescaped HTML content
	// so we must create a component to render it.
	var scriptsDone = [];
	
	function evalScript(data) {
	    var decodedData = decodeURI(data);
	    if (scriptsDone.indexOf(decodedData) !== -1) {
	        return;
	    }
	
	    var head = document.getElementsByTagName('head')[0] || document.documentElement;
	    var script = document.createElement('script');
	
	    script.type = 'text/javascript';
	    script.appendChild(document.createTextNode(decodedData));
	    head.insertBefore(script, head.firstChild);
	    head.removeChild(script);
	
	    console.log('idcta-html evaluating script', decodedData);
	    scriptsDone.push(decodedData);
	}
	
	this.on('mount', function () {
	    _this.root.innerHTML = opts.html;
	    if (opts.htmlJs) {
	        evalScript(opts.htmlJs);
	    }
	
	    console.log('Mounted idcta-html', _this.root);
	
	    if (opts.trackUpsellSignIn && opts.trackUpsellRegister) {
	        var links = _this.root.querySelectorAll('a');
	
	        if (links.length === 2) {
	            links.item(0).onclick = opts.trackUpsellSignIn;
	            links.item(1).onclick = opts.trackUpsellRegister;
	        }
	    }
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-list', '<div id="notifications-wrapper" onmousewheel="{this.onListMouseWheel}" onscroll="{this.onListScroll}"> <ul if="{opts.notifications.length}" class="notification-items" aria-live="polite" aria-relevant="additions" aria-atomic="true"> <li class="notification-item notification__item--js {status ? \'notification-\' + status : \'\'}" each="{opts.notifications}"> <a class="notification-item--link" href="{notification.url}" onclick="{this.onLinkClick}" onkeydown="{this.onLinkKeyDown}"> <div class="notification-icon-and-dot notification-{product.toLowerCase()}"> <span class="notification-dot {status ? \'notification-\' + status : \'\'}"></span> <div class="notifications-image notification-{product.toLowerCase()}-icon"> </div> </div> <div class="notification-text {status ? \'notification-\' + status : \'\'}"> <div class="notification-title-items"> <div> <p class="notification-text-body notifications-long-primer">{this.title(notification)}</p> </div> <div class="notification-item--info"> <span class="notification-episode-name notifications-brevier">{this.label(notification.episode, product)}</span> <span class="notification-time notifications-brevier">{sampleWhen ? sampleWhen : this.timeago(creationTimestamp)}</span> </div> </div> </div> </a> </li> </ul> <div class="spinner" if="{opts.loadingMore}"> <img class="loader-icon notifications-image spinner__img--svg" riot-src="{this.basePath + \'/svg/loader.svg\'}" alt="Spinner"> </div> <div class="notifications-keyboard-access" if="{this.showKeyboardAccess}"> <button class="notifications-keyboard-access--btn notifications-keyboard-access--more" onclick="{this.keyboardLoadMore}" __disabled="{opts.reachedEnd}">Load More</button> <button name="notificationsKeyboardClose" class="notifications-keyboard-access--btn notifications-keyboard-access--close" onclick="{this.closeDrawer}" onkeydown="{this.onKeyboardCloseDown}">Close</button> </div> </div>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	var Utils = __webpack_require__(4);
	var notificationsAnalytics = __webpack_require__(1);
	this.timeago = __webpack_require__(40);
	
	this.utils = new Utils();
	
	var listShadowOffset = 0;
	var loadMoreBuffer = 50;
	this.basePath = opts.mainApp.basePath;
	
	this.on('mount', function () {
	    console.log('LIST MOUNTED', opts);
	});
	
	this.loadMore = function () {
	    // eslint-disable-line consistent-return
	    console.log('Active element', document.activeElement);
	    if (document.activeElement && document.activeElement.classList && (document.activeElement.classList.contains('notification-item--link') || document.activeElement.classList.contains('notifications-keyboard-access--btn'))) {
	        return false;
	    }
	
	    console.log('Component app', opts.componentApp);
	
	    if (!opts.componentApp.loadingMore && !opts.componentApp.reachedEnd) {
	        console.warn('Load more...');
	        opts.componentApp.fetchNotifications(true);
	    }
	};
	
	// Calculate overflow block
	this.onListMouseWheel = function (e) {
	    e.preventUpdate = true;
	
	    if (!opts.notifications.length) {
	        return true;
	    }
	
	    if (e.currentTarget.offsetHeight >= e.currentTarget.scrollHeight) {
	        return true;
	    }
	
	    if (e.deltaY > 0) {
	        return !(e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight);
	    }
	
	    return !(e.currentTarget.scrollTop === 0);
	};
	
	this.onListScroll = function (e) {
	    e.preventUpdate = true;
	
	    // Calculate shadow
	    if (!_this.parent.shadowAdded && e.currentTarget.scrollTop > listShadowOffset) {
	        _this.parent.update({ shadowAdded: true });
	    } else if (_this.parent.shadowAdded && e.currentTarget.scrollTop <= listShadowOffset) {
	        _this.parent.update({ shadowAdded: false });
	    }
	
	    // Calculate load more
	    if (e.currentTarget.scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight - loadMoreBuffer) {
	        _this.loadMore();
	    }
	};
	
	this.capitalizeFirstLetter = function (str) {
	    if (str.toLowerCase() === 'iplayer') {
	        return 'iPlayer';
	    }
	
	    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	};
	
	this.closeDrawer = function () {
	    document.getElementById('notification-link').click();
	
	    if (document.activeElement) {
	        document.querySelector('.orb-nav-news a').focus();
	    }
	};
	
	this.onLinkClick = function (e) {
	    var link = e.item.notification.url;
	    var status = _this.getAnalyticsNotificationStatus(e.item.status);
	    // Analytics event (notificationsItem click)
	    notificationsAnalytics.log('click', 'notifications-item', {
	        notifications_id: e.item.id,
	        notifications_state: status,
	        notifications_priority: (e.item.priority || 'normal').toLowerCase(),
	        notifications_product: e.item.product.toLowerCase(),
	        notifications_type: e.item.type.toLowerCase(),
	        notifications_title: e.item.notification.title,
	        topic_name: notificationsAnalytics.serialiseTopic(e.item.topic)
	    });
	
	    opts.componentApp.notificationsModel.markRead(e.item).then(function () {
	        window.location.assign(link);
	    });
	
	    if (e.preventDefault) {
	        e.preventDefault();
	    }
	
	    return false;
	};
	
	this.getAnalyticsNotificationStatus = function (status) {
	    switch (status) {
	        case 'new':
	            return 'blueDot';
	        case 'unread':
	            return 'new';
	        default:
	            return 'read';
	    }
	};
	
	this.onLinkKeyDown = function (e) {
	    if (e.keyCode === 9) {
	        // Tab
	        var next = document.activeElement.parentNode.nextSibling;
	        var endOfList = !(next.classList && next.classList.contains('notification-item'));
	
	        if (endOfList) {
	            _this.update({ showKeyboardAccess: true });
	        }
	    }
	
	    return true;
	};
	
	this.onKeyboardCloseDown = function (e) {
	    if (e.keyCode === 9 && !e.shiftKey) {
	        // Tab
	        document.querySelector('.notifications__settings--js').focus();
	        return false;
	    }
	
	    return true;
	};
	
	this.keyboardLoadMore = function () {
	    var numNotifications = document.querySelectorAll('.notification-items .notification-item').length;
	    console.log('Load more from keyboard', numNotifications);
	    opts.componentApp.fetchNotifications(true).then(function () {
	        var next = document.querySelector('.notification-items\n                    .notification-item:nth-child(' + (numNotifications + 1) + ') a');
	
	        console.log('Loaded more from keyboard', next, _this.notificationsKeyboardClose);
	
	        if (next) {
	            next.focus();
	        } else {
	            _this.notificationsKeyboardClose.focus();
	        }
	    });
	};
	
	this.title = function (notification) {
	    var dash = '–';
	    return notification.title + (notification.episode ? ' ' + dash + ' ' + notification.episode : '');
	};
	
	this.label = function (episode, product) {
	    return _this.capitalizeFirstLetter(product);
	};
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-onboarded-view', '<bbc-notifications-onboarding-u13-success if="{this.showU13Success}" main-app="{opts.mainApp}"></bbc-notifications-onboarding-u13-success> <div class="notifications-main notifications__container notifications-{this.view} notifications-{this.view}--js notifications-main--css notification-signed-in"> <bbc-notifications-home-view if="{this.view === \'home\'}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}"></bbc-notifications-home-view> <bbc-notifications-settings-view if="{this.view === \'settings\'}" main-app="{opts.mainApp}" component-app="{opts.componentApp}"></bbc-notifications-settings-view> </div>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	var notificationsAnalytics = __webpack_require__(1);
	
	this.view = opts.view;
	
	this.on('mount', function () {
	    if (typeof localStorage !== 'undefined') {
	        if (opts.state.signedIn && localStorage.getItem('bbc-notifications-u13-pending-policy')) {
	            _this.update({ showU13Success: true });
	            localStorage.removeItem('bbc-notifications-u13-pending-policy');
	        }
	    }
	});
	
	this.hideU13Success = function () {
	    _this.update({ showU13Success: false });
	};
	
	this.openSettings = function () {
	    notificationsAnalytics.log('click', 'notifications-settings');
	    _this.update({ view: 'settings' });
	    return false;
	};
	
	this.closeSettings = function () {
	    _this.update({ view: 'home' });
	    return false;
	};
	
	this.on('updated', function () {
	    console.log('Onboarded view updated');
	    opts.mainApp.updateDrawerHeight();
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-onboarding-async', '<div class="spinner"> <img class="loader-icon notifications-image spinner__img--svg" riot-src="{this.parent.parent.opts.mainApp.basePath + \'/svg/loader.svg\'}" alt="Spinner"> </div>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	this.on('mount', function () {
	    _this.parent.parent.opts.mainApp.loadOnboarding(function (onboard) {
	        var onboardOpts = {
	            onboard: onboard,
	            mainApp: _this.parent.parent.opts.mainApp,
	            componentApp: _this.parent.parent.parent
	        };
	        riot.mount(_this.root, 'bbc-notifications-onboarding', onboardOpts);
	    });
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-onboarding-u13-success', '<div class="notifications__container"> <div class="notifications-banner--row"> <span><i1-8n>copy.under13.done</i1-8n></span> <button class="notifications-banner--close" onclick="{parent.hideU13Success}"> <img riot-src="{this.basePath + \'/svg/close_icon.svg\'}" alt="Close"> </button> </div> </div>', '', '', function(opts) {
	"use strict";
	
	this.basePath = opts.mainApp.basePath;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-onboarding-u13', '<div class="notifications-full notifications-u13--onboarding-image"> <div class="notifications__container"> <div class="notifications-u13--close-drawer" onclick="{close}"></div> <div class="notifications-u13--content"> <div class="notifications-layout"> <div class="notifications-layout__item gel-bp-s-8/12 gel-bp-m-6/12"> <div if="{opts.state.policyIssue === \'parentId\'}" id="bbc-notifications-onboarding-u13-parentID"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.parentId.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.parentId.body</i1-8n></p> </div> <div if="{opts.state.policyIssue === \'linkPending\'}" id="bbc-notifications-onboarding-u13-linkPending"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.linkPending.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.linkPending.body</i1-8n></p> </div> <div if="{opts.state.policyIssue === \'permissionNotifications\'}" id="bbc-notifications-onboarding-u13-permissionNotifications"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.permissionNotifications.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.permissionNotifications.body</i1-8n></p> </div> </div> </div> <div class="notifications-layout"> <div class="notifications-20/24 notifications-layout__item notifications-u13--options"> <div if="{opts.state.policyIssue === \'parentId\'}"> <a href="{buttonLink}" class="notifications-u13--ok-button notifications-pica-bold"><span><i1-8n>copy.under13.parentId.button</i1-8n></span></a> </div> <div class="notifications-u13--more"> <a href="{this.moreInfoLink}" class="notifications-pica-bold"><span class="notifications-u13--info-icon"></span><i1-8n>copy.under13.moreInfo</i1-8n></a> </div> </div> </div> </div> <div class="notifications-u13--overlay"></div> </div> </div>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	var config = __webpack_require__(3);
	
	this.moreInfoLink = config.env.under13s.moreInfo;
	
	this.close = function () {
	    opts.mainApp.navNotificationElement.click();
	};
	
	this.on('mount', function () {
	    // Extracts the upsell button link from IDCTA html
	    // To be ripped out if/when ID updates their responses
	    if (opts.state.idctaResponse && opts.state.idctaResponse.html && opts.state.policyIssue && opts.state.policyIssue === 'parentId') {
	        var link = opts.state.idctaResponse.html.match(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"/);
	        if (link[1]) {
	            _this.update({ buttonLink: link[1] });
	        }
	    }
	
	    if (typeof localStorage !== 'undefined') {
	        localStorage.setItem('bbc-notifications-u13-pending-policy', true);
	    }
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-settings-view', '<header class="notifications__header notifications__header--js"> <h2 class="notification-title notification-title--js"><i1-8n>Notifications Settings</i1-8n></h2> <ul class="notification-header-icons"> <li> <a href="javascript:;" class="notifications__settings__back-btn--js" onkeydown="{this.onBackKeydown}" onclick="{parent.closeSettings}" role="link" title="Go back" alt="Go back" aria-label="Go back"><img class="setting-icon notifications-image" riot-src="{this.basePath + \'/svg/arrow_left_black.svg\'}" alt="back"><span class="notifications-brevier"><i1-8n>Back</i1-8n></span></a> </li> </ul> </header> <div class="notifications-settings-description"> <p class="notifications-long-primer"><i1-8n>copy.settings</i1-8n></p> </div> <div each="{this.products}" class="notifications-settings-item notifications-settings-product--js" role="checkbox" aria-checked="{enabled}"> <label tabindex="0" onkeydown="{this.onLabelKeydown}"> <div class="notifications-long-primer notifications-settings-text">{this.getProductSettingLabel(product)}</div> <input type="checkbox" name="checkbox" id="{product}-settings-checkbox" class="notifications-settings-tickbox" value="{product}" __checked="{enabled}" onchange="{this.productChange}"> <div class="notifications-settings-checkbox-hold"></div> </label> </div>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	var notificationsAnalytics = __webpack_require__(1);
	var userPreferences = __webpack_require__(2);
	var i18n = __webpack_require__(5);
	
	this.friendlyProductNames = userPreferences.friendlyProductNames;
	this.basePath = opts.mainApp.basePath;
	
	this.getProductSettingLabel = function (type) {
	    return i18n.localise('{product} Notifications', { //eslint-disable-line
	        product: _this.friendlyProductNames[type]
	    });
	};
	
	this.updatePref = function (item, box) {
	    item.enabled = box.checked;
	
	    console.log('Product change', item, box.checked);
	
	    userPreferences.set({
	        preferences: {
	            lastReadFlag: false,
	            productsEnabled: _this.products
	        }
	    }).catch(function (err) {
	        box.checked = !box.checked;
	
	        item.enabled = box.checked;
	
	        opts.componentApp.update({
	            error: {
	                inner: 'settings'
	            }
	        });
	
	        throw err;
	    }).then(function () {
	        console.info('Pref update succeeded');
	
	        notificationsAnalytics.log(item.enabled ? 'opt-in' : 'opt-out', 'notifications-settings', {
	            nots_product: item.product.toLowerCase()
	        });
	
	        console.log('Settings component', opts.componentApp);
	        opts.componentApp.resetNotifications();
	    });
	};
	
	this.productChange = function (e) {
	    console.log('Product change event', e);
	    _this.updatePref(e.item, e.currentTarget);
	};
	
	this.onBackKeydown = function (e) {
	    if (e.keyCode === 9 && e.shiftKey) {
	        // Tab forwards
	        document.querySelector('.notifications-settings-product--js:last-child label').focus();
	        return false;
	    } else if (e.keyCode === 13) {
	        // Enter
	        _this.parent.updateFocus = '.notifications__settings--js';
	    }
	
	    return true;
	};
	
	this.onLabelKeydown = function (e) {
	    if (e.keyCode === 9 && !e.shiftKey) {
	        // Tab backwards
	        var next = document.activeElement.parentNode.nextSibling;
	        var endOfList = !(next.classList && next.classList.contains('notifications-settings-product--js'));
	
	        if (endOfList) {
	            document.querySelector('.notifications__settings__back-btn--js').focus();
	            return false;
	        }
	    } else if (e.keyCode === 13) {
	        // Enter
	        var box = e.currentTarget.querySelector('input');
	        console.log('Enter on label', box);
	        box.checked = !box.checked;
	
	        _this.updatePref(e.item, box);
	
	        return false;
	    }
	
	    return true;
	};
	
	this.on('mount', function () {
	    var pref = userPreferences.get();
	    _this.update({ products: pref.preferences.productsEnabled });
	
	    console.log('Settings products', _this.products);
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-signed-in-view', '<bbc-notifications-onboarding-async if="{opts.state.onboarded === false && opts.loadOnboarding}"></bbc-notifications-onboarding-async> <bbc-notifications-onboarding-u13 if="{opts.state.onboarded === true && opts.state.policyIssue}" main-app="{opts.mainApp}" state="{opts.state}"></bbc-notifications-onboarding-u13> <bbc-notifications-onboarded-view if="{opts.state.onboarded === true && !opts.state.policyIssue}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" state="{opts.state}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}" view="{opts.view}"></bbc-notifications-onboarded-view>', '', '', function(opts) {
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications-signed-out-view', '<div class="notifications-main notifications-main--css notifications-main--js notification-signed-out"> <div class="notifications-wide-spread"> <div class="notifications__container"> <div class="notifications-top-header"> <p class="notifications-main-header notifications-trafalgar"><i1-8n>copy.upsell.title</i1-8n></p> <p class="notifications-description notifications-pica"><i1-8n>copy.upsell.body</i1-8n></p> </div> <div class="notifications-cta notifications-cta--upsell"> <bbc-notifications-idcta-html html="{opts.state.idctaResponse.html}" html-js="{opts.state.idctaResponse.htmlJs}" track-upsell-sign-in="{this.trackUpsellSignIn}" track-upsell-register="{this.trackUpsellRegister}"></bbc-notifications-idcta-html> </div> </div> </div> </div>', '', '', function(opts) {
	'use strict';
	
	var notificationsAnalytics = __webpack_require__(1);
	
	this.trackUpsellSignIn = function () {
	    console.log('Tracking upsell sign in');
	    notificationsAnalytics.log('sign-in', 'notifications-upsell');
	    return true;
	};
	
	this.trackUpsellRegister = function () {
	    console.log('Tracking upsell register');
	    notificationsAnalytics.log('register', 'notifications-upsell');
	    return true;
	};
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(riot) {riot.tag2('bbc-notifications', '<bbc-notifications-bell main-app="{opts.mainApp}" state="{this.state}" alert="{this.alert}"></bbc-notifications-bell> <bbc-notifications-drawer main-app="{opts.mainApp}" component-app="{this}" state="{this.state}" notifications="{this.notifications}" reached-end="{this.reachedEnd}" loading-more="{this.loadingMore}" error="{this.error}" orb="{opts.orb}" load-onboarding="{this.loadOnboarding}" view="{this.view}"></bbc-notifications-drawer>', '', '', function(opts) {
	'use strict';
	
	var _this = this;
	
	__webpack_require__(12);
	var config = __webpack_require__(3);
	var notificationsAnalytics = __webpack_require__(1);
	var NotificationsModelClass = __webpack_require__(34).NotificationsModel;
	var userPreferencesModel = __webpack_require__(2);
	var StateClass = __webpack_require__(35).UserState;
	
	var state = new StateClass();
	console.log('State module', state);
	
	this.alert = false;
	this.notifications = [];
	this.reachedEnd = false;
	this.loadingMore = false;
	this.error = {};
	this.loadOnboarding = false;
	this.view = 'home';
	
	this.loadState = function () {
	    return state.load().then(function (stateData) {
	        console.log('State', stateData);
	        _this.update({ state: stateData });
	
	        if (stateData.signedIn === true) {
	            if (stateData.onboarded === false || stateData.onboarded === true && stateData.policyIssue) {
	                _this.update({ alert: true });
	            } else if (stateData.onboarded === true && !stateData.policyIssue) {
	                userPreferencesModel.fetch(false).then(function () {
	                    return _this.initModel();
	                });
	            }
	        }
	    }).catch(function (err) {
	        console.error('State failed to load', err);
	        notificationsAnalytics.log('error1-retrieve-fail', 'notifications-error');
	        _this.setError('main', 'hub');
	    }).then(function () {
	        _this.trigger('stateLoaded');
	    });
	};
	
	this.on('mount', this.loadState);
	
	this.on('notificationsUserOnboardedOutsideDrawer', function () {
	    console.log('noticed that user has been onboarded OUTSIDE PANEL');
	    this.loadState();
	});
	
	this.initModel = function () {
	    if (!_this.notificationsModel) {
	        console.log('Instantiating model class');
	        _this.notificationsModel = new NotificationsModelClass();
	        console.log('Fetching notifications');
	        _this.fetchNotifications();
	        window.setInterval(_this.fetchNotifications, config.env.notificationsPollingInterval);
	        window.setInterval(_this.fetchPreferences, config.env.preferencesPollingInterval);
	    }
	};
	
	this.fetchNotifications = function (fetchNext) {
	    if (fetchNext) {
	        _this.update({ loadingMore: true });
	    }
	
	    var prevNotificationsLength = _this.notifications.length;
	
	    return _this.notificationsModel.fetch(fetchNext).catch(function (err) {
	        notificationsAnalytics.log('error2-update-fail', 'notifications-error');
	        _this.setError('main', 'hub');
	        throw err;
	    }).then(function (response) {
	        if (!response) {
	            return;
	        }
	
	        var notifications = response.notifications;
	        var reachedEnd = response.reachedEnd;
	
	        console.log('Notifications', notifications.length, notifications, reachedEnd ? 'ENDED' : '...');
	
	        _this.notifications = notifications;
	        if (reachedEnd) {
	            _this.reachedEnd = reachedEnd;
	        }
	        _this.loadingMore = false;
	
	        var hasNew = false;
	        notifications.forEach(function (i) {
	            if (i.status === 'new') {
	                hasNew = true;
	            }
	        });
	
	        console.warn('Has new?', hasNew);
	        if (hasNew) {
	            notificationsAnalytics.logNewNotifications(_this.notifications, opts.mainApp);
	
	            if (notifications.length > prevNotificationsLength) {
	                _this.alert = true;
	            }
	        }
	
	        _this.removeError('main');
	
	        _this.update();
	        _this.trigger('fetchedNotifications');
	    });
	};
	
	this.fetchPreferences = function () {
	    console.log('Refetching preferences from interval');
	    userPreferencesModel.fetch().catch(function (err) {
	        notificationsAnalytics.log('error2-update-fail', 'notifications-error');
	        _this.setError('main', 'hub');
	        throw err;
	    }).then(function () {
	        _this.removeError('main');
	    });
	};
	
	this.setError = function (type, val) {
	    console.error('Displaying error', type, val);
	    _this.error[type] = val;
	    _this.update();
	};
	
	this.removeError = function (type) {
	    delete _this.error[type];
	    _this.update();
	};
	
	this.resetNotifications = function () {
	    _this.update({ notifications: [], reachedEnd: false });
	    _this.notificationsModel.reset();
	    _this.fetchNotifications();
	};
	
	this.drawerStateChangedCallback = function (newState) {
	    console.log('Drawer is now', newState);
	    _this.update({ alert: false });
	
	    if (newState === 'hidden') {
	        console.log('LOGGING drawer been closed.');
	        notificationsAnalytics.log('close-pane', 'notifications-icon');
	
	        if (_this.notificationsModel) {
	            var markedSeen = _this.notificationsModel.markAllAsSeen();
	            _this.update({
	                notifications: markedSeen
	            });
	        }
	    } else {
	        // drawer is being opened
	        console.log('DRAWER is opening.');
	        _this.update({ view: 'home' });
	        if (_this.state) {
	            console.log('got STATE');
	            if (_this.state.signedIn === false) {
	                console.log('SIGNED OUT');
	                // signed out user
	                notificationsAnalytics.log('upsell', 'notifications-icon');
	            } else if (_this.state.onboarded) {
	                // signed in, onboarded
	                console.log('DRAWER IS OPENING AND USER IS ONBOARDED.');
	
	                userPreferencesModel.updateRead(true);
	                notificationsAnalytics.logNewNotifications(_this.notifications, opts.mainApp);
	            } else if (Object.keys(_this.error).length === 0) {
	                console.log('NOT ONBOARDED');
	                // not onboarded and no error, load 1.NotificationsMain now
	                _this.update({ loadOnboarding: true });
	            }
	        }
	    }
	    _this.trigger('drawerStateChanged', newState);
	};
	
	this.on('updated', function () {
	    opts.mainApp.updateWrapperMaxHeight();
	});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable */
	
	var BloomFilter = __webpack_require__(39);
	var Utils = __webpack_require__(4);
	
	var utils = new Utils();
	var DEFAULT_FILTER_VALUE = 32 * 256;
	
	/**
	* Constructor for BloomFilterManager
	* @constructor
	* @param filterName
	*/
	var BloomFilterManager = function () {
	    function BloomFilterManager(filterName) {
	        _classCallCheck(this, BloomFilterManager);
	
	        this.filterName = filterName;
	        this.filter = new BloomFilter(DEFAULT_FILTER_VALUE, 16);
	    }
	
	    /**
	    * OVerride bloomfilter
	    * @param {[[Type]]} newFilter [[Description]]
	    */
	
	
	    _createClass(BloomFilterManager, [{
	        key: 'override',
	        value: function override(newFilter) {
	            if (typeof newFilter === 'string' && newFilter !== '') {
	                newFilter = utils.handledParse(newFilter, []);
	            }
	
	            if (utils.isArray(newFilter) && newFilter.length === 0) {
	                newFilter = DEFAULT_FILTER_VALUE;
	            }
	
	            this.filter = new BloomFilter(newFilter, 16);
	        }
	
	        /**
	        * Checking if value is valid and adding to filter
	        * @param item
	        */
	
	    }, {
	        key: 'add',
	        value: function add(item) {
	            if (item && item !== '') {
	                this.filter.add(item);
	            }
	        }
	
	        /**
	        * Get the value of the cached filter from store
	        * @param item
	        */
	
	    }, {
	        key: 'getCleanArray',
	        value: function getCleanArray() {
	            return [].slice.call(this.filter.buckets);
	        }
	
	        /**
	        * Checking if value is valid and exists in the filter
	        * @param item
	        * @return Boolean
	        */
	
	    }, {
	        key: 'contains',
	        value: function contains(item) {
	            if (item && item !== '') {
	                return this.filter.test(item);
	            }
	
	            return false;
	        }
	
	        /**
	        * If item does not exist, add it to filter.
	        * @param item
	        */
	
	    }, {
	        key: 'checkOrAdd',
	        value: function checkOrAdd(item) {
	            if (item && item !== '') {
	                if (!this.contains(item)) {
	                    this.add(item);
	                }
	            }
	        }
	    }]);
	
	    return BloomFilterManager;
	}();/* harmony export */ Object.defineProperty(exports, "BloomFilterManager", {configurable: false, enumerable: true, get: function() { return BloomFilterManager; }});

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_lite_browsercheck__ = __webpack_require__(15);
	'use strict';
	
	/* eslint global-require: 0, no-underscore-dangle: 0 */
	
	
	__webpack_require__(16);
	
	// IE check
	var main = {
	    run: function run() {
	        // Don't run anything for old IE
	    }
	};
	
	function isOldIE() {
	    var myNav = navigator.userAgent.toLowerCase();
	    return myNav.indexOf('msie') !== -1 ? parseInt(myNav.split('msie')[1], 10) <= 9 : false;
	}
	
	if (!isOldIE()) {
	    // Riot components
	    __webpack_require__(17);
	    __webpack_require__(18);
	    __webpack_require__(23);
	    __webpack_require__(28);
	    __webpack_require__(25);
	    __webpack_require__(27);
	    __webpack_require__(26);
	    __webpack_require__(19);
	    __webpack_require__(20);
	    __webpack_require__(22);
	    __webpack_require__(29);
	    __webpack_require__(30);
	    __webpack_require__(24);
	    __webpack_require__(21);
	    __webpack_require__(31);
	
	    var i18n = __webpack_require__(5);
	    var text = __webpack_require__(14);
	    var cookie = __webpack_require__(13);
	
	    i18n.dictionary(text);
	
	    var lang = cookie.get('ckps_language');
	    console.log('Language', lang);
	
	    if (lang && text[lang]) {
	        console.log('Setting language', lang);
	        i18n.setLanguage(lang);
	    }
	
	    console.log('Getting language', i18n.getLanguage());
	
	    var eventie = __webpack_require__(6);
	    var Utils = __webpack_require__(4);
	
	    var utils = new Utils();
	    var riot = __webpack_require__(0);
	    var userPreferencesModel = __webpack_require__(2);
	
	    var onboarding = void 0;
	
	    main = {
	        name: 'mainApp',
	        drawerName: 'notifications',
	        errorState: false,
	        notificationPanelCreated: false,
	
	        /**
	         * Sets path received from idcta and runs preparations
	         * @param {Object} idcta    Reference to idcta (Checking user Authentication)
	         * @param {String} basePath - path to files on CDN
	         */
	        run: function run(idcta, basePath) {
	            var _this = this;
	
	            console.log('Requiring root modules');
	
	            if (window.require) {
	                window.require(['orb/nav', 'idcta/id-config'], function (orb, idConfig) {
	                    console.log('Running NotificationsMain');
	
	                    _this.basePath = basePath || '';
	                    __webpack_require__.p = _this.basePath + 'js/'; //eslint-disable-line
	
	                    _this.orb = orb;
	
	                    _this.setIdcta(idcta, idConfig);
	
	                    // Mount top-level Riot tags
	                    var myBBCWrapper = document.getElementById('mybbc-wrapper');
	                    console.log('My BBC', myBBCWrapper);
	                    var notifHold = document.getElementById('notification-link');
	                    console.log('Notif hold', notifHold);
	
	                    if (notifHold) {
	                        myBBCWrapper.removeChild(notifHold);
	                        var newHold = document.createElement('bbc-notifications');
	                        myBBCWrapper.appendChild(newHold);
	                    }
	
	                    riot.mount('bbc-notifications', { orb: orb, mainApp: _this });
	
	                    eventie.addEvent(document, 'ready', _this._setHubResizeEvent());
	                });
	            }
	        },
	        _setHubResizeEvent: function _setHubResizeEvent() {
	            var _this2 = this;
	
	            console.warn('Setting resize event');
	            var resizeTimeout = void 0;
	
	            // MYNOT-374: Fixing the Hub height resize on devices and desktop
	            ['resize', 'orientationchange'].forEach(function (eventName) {
	                eventie.addEvent(window, eventName, function () {
	                    if (resizeTimeout) {
	                        clearTimeout(resizeTimeout);
	                    }
	
	                    resizeTimeout = setTimeout(utils.bind(_this2.updateWrapperMaxHeight, _this2), 100);
	                });
	            });
	
	            this.updateWrapperMaxHeight();
	        },
	
	
	        /**
	         * Sets the app idcta property
	         * @param {Object} idcta
	         */
	        setIdcta: function setIdcta(idcta, idConfig) {
	            if (typeof idcta.getInstance === 'function') {
	                this.idcta = idcta.getInstance();
	            } else {
	                this.idcta = idcta;
	            }
	
	            this.idConfig = idConfig;
	
	            console.log('IDCTA', this.idcta, idConfig);
	        },
	
	
	        /**
	         * Windows Phone sniffing
	         * @return {Boolean}
	         */
	        isWindowsPhone: function isWindowsPhone() {
	            return navigator.appVersion.indexOf('Win') !== -1 && typeof window.navigator.pointerEnabled !== 'undefined' && navigator.userAgent.match(/.+windows.+(touch|phone).+/i) !== null;
	        },
	        updateWrapperMaxHeight: function updateWrapperMaxHeight() {
	            var maximumWrapperDesktopHeight = 420;
	            var coef = /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__vendor_lite_browsercheck__.touchevents() || this.isWindowsPhone() ? 0.75 : 0.65;
	            var orbitHeaderNavEl = document.querySelector('.orb-nav-pri-container');
	            var orbitHeaderHeight = orbitHeaderNavEl !== null ? orbitHeaderNavEl.offsetHeight : 0;
	            var notificationsHeaderOffset = 44;
	
	            var windowHeight = document.documentElement.clientHeight || window.innerHeight;
	
	            // UX design request 65% of screen height + orb included
	            // MYNOT-411: Fixed the scroll not appearing on certain devices with big heights
	            var newMaxHeight = windowHeight * coef - orbitHeaderHeight - notificationsHeaderOffset;
	
	            // For none mobile and touch devices
	            if (!/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_0__vendor_lite_browsercheck__.touchevents() && !this.isWindowsPhone()) {
	                newMaxHeight = Math.min(newMaxHeight, maximumWrapperDesktopHeight);
	            }
	
	            var wrapper = document.querySelector('#notifications-wrapper');
	            if (wrapper) {
	                wrapper.style.maxHeight = newMaxHeight + 'px';
	            }
	
	            this.orb.updateDrawerHeight(this.drawerName);
	        },
	        updateDrawerHeight: function updateDrawerHeight() {
	            return this.orb.updateDrawerHeight(this.drawerName);
	        },
	        isUserOnBoarded: function isUserOnBoarded() {
	            var preferencesData = userPreferencesModel.get();
	            console.log('Preferences model', preferencesData);
	            var userPreferences = preferencesData.preferences;
	
	            return userPreferences !== null && typeof userPreferences.hasOnboarded !== 'undefined' ? userPreferences.hasOnboarded : false;
	        },
	        loadOnboarding: function loadOnboarding(cb) {
	            console.log('Loading onboarding script');
	
	            this.loadOnboardingStyles();
	
	            __webpack_require__.e/* System.import */(1).then(__webpack_require__.bind(null, 38)).then(cb);
	        },
	        loadOnboardingStyles: function loadOnboardingStyles() {
	            console.log('Loading onboarding stylesheet');
	
	            var fileref = document.createElement('link');
	            fileref.rel = 'stylesheet';
	            fileref.type = 'text/css';
	            fileref.href = this.basePath + 'css/onboarding.min.css';
	            document.getElementsByTagName('head')[0].appendChild(fileref);
	        },
	
	
	        /**
	         * Returns onboarding initialisation parameter
	         * @return {Object}
	         */
	        getOnboardingParams: function getOnboardingParams(componentApp) {
	            return {
	                mainElSelector: '.notifications-on-boarding--js',
	                app: this,
	                componentApp: componentApp,
	                isIE: this.isIE(),
	                resizeEvent: utils.bind(this._setHubResizeEvent, this)
	            };
	        },
	
	
	        /**
	         *  Getting references to the DOM for notifications and change icon based on user state
	         */
	        setNotificationIcon: function setNotificationIcon() {
	            var _this3 = this;
	
	            this.navNotificationElement = document.querySelector('.js-notification-link');
	
	            // MYNOT-679: Accessibility bit
	            this.navNotificationElement.onkeydown = function (e) {
	                var charCode = e.which || e.charCode;
	
	                if (charCode === 13) {
	                    _this3.lastEnterPress = Date.now();
	                }
	            };
	
	            this.orb.refresh();
	        },
	        getNavNotificationEl: function getNavNotificationEl() {
	            return this.navNotificationElement;
	        },
	
	
	        /**
	         * Wrap for ORB api to get drawer state
	         * @returns {[[Type]]} [[Description]]
	         */
	        getDrawerState: function getDrawerState() {
	            return this.orb.getDrawerState(this.drawerName);
	        },
	
	
	        /**
	         * Reset the onboarding carousel when hub closes
	         */
	        resetOnboarding: function resetOnboarding() {
	            onboarding.resetOnboarding();
	            onboarding.init(this.getOnboardingParams());
	        },
	
	
	        /**
	         * Getter for the preferences model
	         * @return {UserPreferences} user preferences model
	         */
	        getUserPreferencesModel: function getUserPreferencesModel() {
	            return userPreferencesModel;
	        },
	
	
	        /**
	         * Check if browser is IE and returns IE version
	         * @returns {Number} Version of IE
	         */
	        isIE: function isIE() {
	            if (document.documentMode) {
	                return document.documentMode;
	            }
	
	            for (var i = 7; i > 0; i--) {
	                var div = document.createElement('div');
	
	                div.innerHTML = '<!--[if IE ' + i + ']><span></span><![endif]-->';
	
	                if (div.getElementsByTagName('span').length) {
	                    return i;
	                }
	            }
	
	            return undefined;
	        },
	
	
	        /**
	         * Removes all the style heights added previously. (For IE)
	         */
	        removeCustomHeights: function removeCustomHeights() {
	            onboarding.removeCustomHeights();
	        }
	    };
	}
	
	module.exports = main;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__collections_AggregatedCollection__ = __webpack_require__(36);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collections_TopicCollection__ = __webpack_require__(37);
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var config = __webpack_require__(3);
	var userPreferencesModel = __webpack_require__(2);
	var readFilter = __webpack_require__(11);
	var find = __webpack_require__(7);
	
	var MAX_SUBSCRIPTIONS_THRESHOLD = config.env.feedTopicMaxSubscriptions;
	
	var NotificationsModel = function () {
	    function NotificationsModel() {
	        _classCallCheck(this, NotificationsModel);
	
	        var numberOfSubscriptions = userPreferencesModel.countActiveSubscriptions();
	        console.log('In constructor');
	        this.notifications = [];
	
	        if (numberOfSubscriptions > MAX_SUBSCRIPTIONS_THRESHOLD) {
	            this.modelInterface = new /* harmony import */ __WEBPACK_IMPORTED_MODULE_0__collections_AggregatedCollection__["AggregatedCollection"]();
	            console.info('Set up model interface', 'AggregatedCollection');
	        } else {
	            this.modelInterface = new /* harmony import */ __WEBPACK_IMPORTED_MODULE_1__collections_TopicCollection__["TopicCollection"]();
	            console.info('Set up model interface', 'TopicCollection');
	        }
	
	        var pref = userPreferencesModel.get();
	        if (pref.preferences) {
	            this.lastRead = new Date(pref.preferences.lastRead);
	            readFilter.override(pref.preferences.readFilter);
	        } else {
	            var newDate = new Date();
	            newDate.setDate(newDate.getDate() - 5);
	            this.lastRead = newDate;
	        }
	
	        console.warn('Last read', this.lastRead);
	        console.warn('Pref model', pref);
	    }
	
	    _createClass(NotificationsModel, [{
	        key: 'populateReadStatus',
	        value: function populateReadStatus(data) {
	            var _this = this;
	
	            data.forEach(function (notif) {
	                if (!readFilter.contains(notif.id)) {
	                    if (new Date(_this.lastRead) < new Date(notif.creationTimestamp)) {
	                        notif.status = 'new';
	                    } else {
	                        notif.status = 'unread';
	                    }
	                } else {
	                    notif.status = null;
	                }
	            });
	
	            return data;
	        }
	    }, {
	        key: 'markRead',
	        value: function markRead(notif) {
	            console.log('Marking read in model', notif);
	            console.log('Bloom filter', readFilter.getCleanArray());
	
	            // Update the bloom filter
	            readFilter.checkOrAdd(notif.id);
	            userPreferencesModel.updateRead();
	
	            console.log('Bloom filter now', readFilter.getCleanArray());
	
	            // Update item
	            notif.status = null;
	
	            return userPreferencesModel.updateRead();
	        }
	    }, {
	        key: 'markAllAsSeen',
	        value: function markAllAsSeen() {
	            console.warn('Marking all as seen...');
	            this.notifications.forEach(function (notif) {
	                if (notif.status === 'new') {
	                    notif.status = 'unread';
	                }
	            });
	
	            return this.notifications;
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            this.notifications = [];
	            return this.fetch();
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var _this2 = this;
	
	            var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            // Fetch notification data from the selected interface
	            return this.modelInterface.fetch(loadMore).then(function (_ref) {
	                var data = _ref.data,
	                    reachedEnd = _ref.reachedEnd;
	
	                // Sort model data in reverse chronological order
	                data.sort(function (a, b) {
	                    return new Date(a.creationTimestamp) >= new Date(b.creationTimestamp) ? 1 : -1;
	                });
	
	                var populatedReadData = _this2.populateReadStatus(data);
	                var sortedData = loadMore ? populatedReadData.reverse() : populatedReadData;
	
	                sortedData.forEach(function (item) {
	                    if (find(_this2.notifications, function (i) {
	                        return i.id === item.id;
	                    })) {
	                        return;
	                    }
	
	                    _this2.notifications[loadMore ? 'push' : 'unshift'](item);
	                });
	
	                return { notifications: _this2.notifications, reachedEnd: reachedEnd };
	            });
	        }
	    }]);
	
	    return NotificationsModel;
	}();/* harmony export */ Object.defineProperty(exports, "NotificationsModel", {configurable: false, enumerable: true, get: function() { return NotificationsModel; }});

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserPreferences__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserPreferences___default = __WEBPACK_IMPORTED_MODULE_0__UserPreferences__ && __WEBPACK_IMPORTED_MODULE_0__UserPreferences__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_0__UserPreferences__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_0__UserPreferences__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0__UserPreferences___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_0__UserPreferences___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __WEBPACK_IMPORTED_MODULE_1__config__ && __WEBPACK_IMPORTED_MODULE_1__config__.__esModule ? function() { return __WEBPACK_IMPORTED_MODULE_1__config__['default'] } : function() { return __WEBPACK_IMPORTED_MODULE_1__config__; }
	/* harmony import */ Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1__config___default, 'a', { get: __WEBPACK_IMPORTED_MODULE_1__config___default });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__idcta__ = __webpack_require__(9);
	/* harmony export */ exports["convertHtml"] = convertHtml;'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var ptrt = encodeURIComponent(window.location.href.replace(window.location.hash, ''));
	
	function convertHtml(html) {
	    var htmlJs = void 0;
	
	    var escapedHtml = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, function (x) {
	        var script = x.substring(x.indexOf('>') + 1);
	        script = script.slice(0, script.indexOf('</script'));
	        htmlJs = script;
	        return '';
	    });
	
	    var result = { html: escapedHtml };
	
	    if (htmlJs) {
	        result.htmlJs = encodeURI(htmlJs);
	    }
	
	    return result;
	}
	
	function checkStatus(response) {
	    if (response.ok) {
	        return response;
	    }
	
	    var error = new Error('HTTP request failed ' + response.statusText);
	    error.response = response;
	    throw error;
	}
	
	function fetchIdcta() {
	    return new Promise(function (resolve, reject) {
	        return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_2__idcta__.lib().then(function (idctaLib) {
	            var userDetails = idctaLib.getUserDetailsFromCookie() || {};
	
	            if (idctaLib.hasCookie() && userDetails.ab !== 'u13') {
	                return resolve(null);
	            }
	
	            return fetch(/* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_1__config__.env.preferencesUrls.idcta + '?policy=notification&buttonColour=white&ptrt=' + ptrt, {
	                credentials: 'include'
	            }).catch(function (err) {
	                throw err;
	            }).then(checkStatus).then(function (res) {
	                return res.json();
	            }).then(function (data) {
	                if (data.html) {
	                    var convertedHtml = convertHtml(data.html);
	
	                    data.html = convertedHtml.html;
	                    if (convertedHtml.htmlJs) {
	                        data.htmlJs = convertedHtml.htmlJs;
	                    }
	                }
	
	                return data;
	            }).then(function (data) {
	                return resolve(data);
	            });
	        }).catch(function (err) {
	            reject(err);
	        });
	    });
	}
	
	var UserState = function () {
	    function UserState() {
	        _classCallCheck(this, UserState);
	    }
	
	    _createClass(UserState, [{
	        key: 'isSignedIn',
	        value: function isSignedIn() {
	            return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_2__idcta__.lib().then(function (idctaLib) {
	                return idctaLib.hasCookie();
	            });
	        }
	    }, {
	        key: 'isOnboarded',
	        value: function isOnboarded() {
	            return /* harmony namespace import */ __WEBPACK_IMPORTED_MODULE_2__idcta__.lib().then(function (idctaLib) {
	                var userDetails = idctaLib.getUserDetailsFromCookie();
	
	                if (userDetails && userDetails.ab === 'u13') {
	                    return true;
	                }
	
	                return /* harmony import */ __WEBPACK_IMPORTED_MODULE_0__UserPreferences___default.a.fetch().then(function (userPreferences) {
	                    return userPreferences !== null && typeof userPreferences.preferences.hasOnboarded !== 'undefined' ? userPreferences.preferences.hasOnboarded : false;
	                });
	            });
	        }
	    }, {
	        key: 'setIdctaResponse',
	        value: function setIdctaResponse(response, idctaData) {
	            response.idctaResponse = idctaData;
	
	            if (idctaData.policyCheck) {
	                response.policyIssue = Object.keys(idctaData.policyCheck)[0];
	            }
	        }
	    }, {
	        key: 'load',
	        value: function load() {
	            var _this = this;
	
	            return Promise.all([this.isSignedIn(), fetchIdcta()]).catch(function (err) {
	                throw err;
	            }).then(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    signedIn = _ref2[0],
	                    idctaData = _ref2[1];
	
	                var response = { signedIn: signedIn };
	
	                if (idctaData) {
	                    _this.setIdctaResponse(response, idctaData);
	                }
	
	                if (!signedIn) {
	                    return response;
	                }
	
	                return _this.isOnboarded().then(function (onboarded) {
	                    response.onboarded = onboarded;
	
	                    return response;
	                });
	            });
	        }
	    }]);
	
	    return UserState;
	}();/* harmony export */ Object.defineProperty(exports, "UserState", {configurable: false, enumerable: true, get: function() { return UserState; }});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseCollection__ = __webpack_require__(10);
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	
	
	var AggregatedCollection = function (_BaseCollection) {
	    _inherits(AggregatedCollection, _BaseCollection);
	
	    function AggregatedCollection() {
	        _classCallCheck(this, AggregatedCollection);
	
	        return _possibleConstructorReturn(this, (AggregatedCollection.__proto__ || Object.getPrototypeOf(AggregatedCollection)).apply(this, arguments));
	    }
	
	    _createClass(AggregatedCollection, [{
	        key: 'fetch',
	        value: function fetch(loadMore) {
	            var _this2 = this;
	
	            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : loadMore ? this.NEXT_DISPLAY_PAGE : 'latest.json';
	            var notifications = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	            return _get(AggregatedCollection.prototype.__proto__ || Object.getPrototypeOf(AggregatedCollection.prototype), 'loadData', this).call(this, 'aggregated', page).then(function (_ref) {
	                var list = _ref.list,
	                    next = _ref.next,
	                    reachedEnd = _ref.reachedEnd;
	
	                if (!list) {
	                    return { data: [], reachedEnd: reachedEnd };
	                }
	
	                if (!next) {
	                    reachedEnd = true;
	                }
	
	                console.warn('Got aggregate page back', list, next, reachedEnd);
	
	                var concatNotifications = notifications.concat(list);
	                var filteredData = _get(AggregatedCollection.prototype.__proto__ || Object.getPrototypeOf(AggregatedCollection.prototype), 'filterData', _this2).call(_this2, concatNotifications);
	                var dedupedData = _get(AggregatedCollection.prototype.__proto__ || Object.getPrototypeOf(AggregatedCollection.prototype), 'dedupeData', _this2).call(_this2, filteredData);
	
	                if (dedupedData.length >= _this2.MINIMUM_TO_DISPLAY || reachedEnd) {
	                    if (!_this2.NEXT_DISPLAY_PAGE || loadMore && !reachedEnd && next) {
	                        _this2.NEXT_DISPLAY_PAGE = next;
	                    }
	
	                    return { data: dedupedData, reachedEnd: reachedEnd };
	                }
	
	                return _this2.fetch(loadMore, next, dedupedData);
	            });
	        }
	    }]);
	
	    return AggregatedCollection;
	}(/* harmony import */ __WEBPACK_IMPORTED_MODULE_0__BaseCollection__["BaseCollection"]);/* harmony export */ Object.defineProperty(exports, "AggregatedCollection", {configurable: false, enumerable: true, get: function() { return AggregatedCollection; }});

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseCollection__ = __webpack_require__(10);
	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	
	
	var TopicCollection = function (_BaseCollection) {
	    _inherits(TopicCollection, _BaseCollection);
	
	    function TopicCollection() {
	        _classCallCheck(this, TopicCollection);
	
	        var _this = _possibleConstructorReturn(this, (TopicCollection.__proto__ || Object.getPrototypeOf(TopicCollection)).call(this));
	
	        _this.TOPIC_NEXT_DISPLAY_PAGE = {};
	        _this.TOPIC_REACHED_END = {};
	        _this.notifications = [];
	        return _this;
	    }
	
	    _createClass(TopicCollection, [{
	        key: 'loadTopicPage',
	        value: function loadTopicPage(topic, loadMore, page) {
	            var _this2 = this;
	
	            return _get(TopicCollection.prototype.__proto__ || Object.getPrototypeOf(TopicCollection.prototype), 'loadData', this).call(this, topic.topic, page).then(function (_ref) {
	                var list = _ref.list,
	                    next = _ref.next,
	                    reachedEnd = _ref.reachedEnd;
	
	                if (!list) {
	                    return { data: [], reachedEnd: reachedEnd, topic: topic };
	                }
	
	                if (!_this2.TOPIC_NEXT_DISPLAY_PAGE[topic.topic] || loadMore && !reachedEnd && next) {
	                    _this2.TOPIC_NEXT_DISPLAY_PAGE[topic.topic] = next;
	                }
	
	                var filteredData = _get(TopicCollection.prototype.__proto__ || Object.getPrototypeOf(TopicCollection.prototype), 'filterData', _this2).call(_this2, list);
	
	                if (reachedEnd || !filteredData.length || !next || next === 'false') {
	                    _this2.TOPIC_REACHED_END[topic.topic] = true;
	                }
	
	                return { data: filteredData, reachedEnd: reachedEnd, topic: topic };
	            });
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(loadMore) {
	            var _this3 = this;
	
	            this.perTopicNotifications = {};
	            var promises = [];
	            if (!loadMore) {
	                this.notifications = [];
	            }
	
	            this.topics.forEach(function (topic) {
	                if (!_this3.TOPIC_REACHED_END[topic.topic] || !loadMore) {
	                    promises.push(_this3.loadTopicPage(topic, loadMore, loadMore ? _this3.TOPIC_NEXT_DISPLAY_PAGE[topic.topic] : 'latest.json').then(function (notif) {
	                        _this3.notifications = _this3.notifications.concat(notif.data);
	                        return notif;
	                    }));
	                }
	            });
	
	            return Promise.all(promises).then(function (vals) {
	                var reachedEnd = vals.every(function (i) {
	                    return i.reachedEnd;
	                });
	                var deduped = _get(TopicCollection.prototype.__proto__ || Object.getPrototypeOf(TopicCollection.prototype), 'dedupeData', _this3).call(_this3, _this3.notifications);
	
	                if (deduped.length >= _this3.MINIMUM_TO_DISPLAY || reachedEnd) {
	                    return { data: deduped, reachedEnd: reachedEnd };
	                }
	
	                return _this3.fetch(true);
	            });
	        }
	    }]);
	
	    return TopicCollection;
	}(/* harmony import */ __WEBPACK_IMPORTED_MODULE_0__BaseCollection__["BaseCollection"]);/* harmony export */ Object.defineProperty(exports, "TopicCollection", {configurable: false, enumerable: true, get: function() { return TopicCollection; }});

/***/ },
/* 38 */,
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	var typedArrays = typeof ArrayBuffer !== "undefined";
	
	// Creates a new bloom filter.  If *m* is an array-like object, with a length
	// property, then the bloom filter is loaded with data from the array, where
	// each element is a 32-bit integer.  Otherwise, *m* should specify the
	// number of bits.  Note that *m* is rounded up to the nearest multiple of
	// 32.  *k* specifies the number of hashing functions.
	function BloomFilter(m, k) {
	    var a;
	    if (typeof m !== "number") a = m, m = a.length * 32;
	
	    var n = Math.ceil(m / 32),
	        i = -1;
	    this.m = m = n * 32;
	    this.k = k;
	
	    if (typedArrays) {
	        var kbytes = 1 << Math.ceil(Math.log(Math.ceil(Math.log(m) / Math.LN2 / 8)) / Math.LN2),
	            array = kbytes === 1 ? Uint8Array : kbytes === 2 ? Uint16Array : Uint32Array,
	            kbuffer = new ArrayBuffer(kbytes * k),
	            buckets = this.buckets = new Int32Array(n);
	        if (a) while (++i < n) {
	            buckets[i] = a[i];
	        }this._locations = new array(kbuffer);
	    } else {
	        var buckets = this.buckets = [];
	        if (a) while (++i < n) {
	            buckets[i] = a[i];
	        } else while (++i < n) {
	            buckets[i] = 0;
	        }this._locations = [];
	    }
	}
	
	// See http://willwhim.wordpress.com/2011/09/03/producing-n-hash-functions-by-hashing-only-once/
	BloomFilter.prototype.locations = function (v) {
	    var k = this.k,
	        m = this.m,
	        r = this._locations,
	        a = fnv_1a(v),
	        b = fnv_1a_b(a),
	        i = -1,
	        x = a % m;
	    while (++i < k) {
	        r[i] = x < 0 ? x + m : x;
	        x = (x + b) % m;
	    }
	    return r;
	};
	
	BloomFilter.prototype.add = function (v) {
	    var l = this.locations(v + ""),
	        i = -1,
	        k = this.k,
	        buckets = this.buckets;
	    while (++i < k) {
	        buckets[Math.floor(l[i] / 32)] |= 1 << l[i] % 32;
	    }
	};
	
	BloomFilter.prototype.test = function (v) {
	    var l = this.locations(v + ""),
	        i = -1,
	        k = this.k,
	        b,
	        buckets = this.buckets;
	    while (++i < k) {
	        b = l[i];
	        if ((buckets[Math.floor(b / 32)] & 1 << b % 32) === 0) {
	            return false;
	        }
	    }
	    return true;
	};
	
	// Estimated cardinality.
	BloomFilter.prototype.size = function () {
	    var buckets = this.buckets,
	        bits = 0;
	    for (var i = 0, n = buckets.length; i < n; ++i) {
	        bits += popcnt(buckets[i]);
	    }return -this.m * Math.log(1 - bits / this.m) / this.k;
	};
	
	// http://graphics.stanford.edu/~seander/bithacks.html#CountBitsSetParallel
	function popcnt(v) {
	    v -= v >> 1 & 0x55555555;
	    v = (v & 0x33333333) + (v >> 2 & 0x33333333);
	    return (v + (v >> 4) & 0xF0F0F0F) * 0x1010101 >> 24;
	}
	
	// Fowler/Noll/Vo hashing.
	function fnv_1a(v) {
	    var n = v.length,
	        a = 2166136261,
	        c,
	        d,
	        i = -1;
	    while (++i < n) {
	        c = v.charCodeAt(i);
	        if (d = c & 0xff000000) {
	            a ^= d >> 24;
	            a += (a << 1) + (a << 4) + (a << 7) + (a << 8) + (a << 24);
	        }
	        if (d = c & 0xff0000) {
	            a ^= d >> 16;
	            a += (a << 1) + (a << 4) + (a << 7) + (a << 8) + (a << 24);
	        }
	        if (d = c & 0xff00) {
	            a ^= d >> 8;
	            a += (a << 1) + (a << 4) + (a << 7) + (a << 8) + (a << 24);
	        }
	        a ^= c & 0xff;
	        a += (a << 1) + (a << 4) + (a << 7) + (a << 8) + (a << 24);
	    }
	    // From http://home.comcast.net/~bretm/hash/6.html
	    a += a << 13;
	    a ^= a >> 7;
	    a += a << 3;
	    a ^= a >> 17;
	    a += a << 5;
	    return a & 0xffffffff;
	}
	
	// One additional iteration of FNV, given a hash.
	function fnv_1a_b(a) {
	    a += (a << 1) + (a << 4) + (a << 7) + (a << 8) + (a << 24);
	    a += a << 13;
	    a ^= a >> 7;
	    a += a << 3;
	    a ^= a >> 17;
	    a += a << 5;
	    return a & 0xffffffff;
	}
	
	module.exports = BloomFilter;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var i18n = __webpack_require__(5);
	
	module.exports = function (timestamp) {
	    var dateValue = new Date(timestamp);
	    var serverDate = new Date();
	
	    var timeInHours = Math.floor(Math.abs(serverDate - dateValue) / 36e5);
	    var timeInMinutes = Math.floor(Math.abs(serverDate - dateValue) / 6e4);
	
	    if (timeInHours > 23 && timeInHours < 48) {
	        return i18n.localise('Yesterday');
	    } else if (timeInHours >= 48 && timeInHours < 168) {
	        return (timeInHours / 24).toFixed(0) + ' ' + i18n.localise('days ago');
	    } else {
	        return timeInHours > 0 ? timeInHours + ' ' + i18n.localise('hour' + (timeInHours === 1 ? '' : 's') + ' ago') : timeInMinutes > 0 ? timeInMinutes + ' ' + i18n.localise('minute' + (timeInMinutes === 1 ? '' : 's') + ' ago') : i18n.localise('Just now');
	    }
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }
/******/ ])});;


/** WEBPACK FOOTER **
 ** NotificationsMain.js
 **/